// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-05T18:34:41.272Z
// Property: Neuhaus (Woodlands) (ID: 6767906449167905)
// Collections: 40 amenities, 12 floorplans (live), 30 photos, 74 POIs, 5 reviews, 1 virtual tours, 6 office hours, 2 fees (live)
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162393",
  "multihub_property_id": "6767906449167905",
  "property_external_id": "100185814",
  "property_zillow_url": "https://www.zillow.com/apartments/spring-tx/neuhaus/CrVKP9/",
  "property_apartments_url": "https://www.apartments.com/neuhaus-spring-tx/cl70emg/",
  "property_google_business_url": "https://www.google.com/maps/place/?q=place_id:ChIJsfcS_T03R4YR_0EZAURoR7k",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": "Entrata",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "neuhaus-(woodlands)",
  "property_name": "Neuhaus (Woodlands)",
  "property_website_url": "https://www.liveneuhaus.com/",
  "property_domain": "https://www.liveneuhaus.com/",
  "property_address": "509 Nursery Rd",
  "property_full_address": "509 Nursery Rd, Spring, TX 77380",
  "property_address_1": "509 Nursery Rd",
  "property_address_2": null,
  "property_address_city": "Spring",
  "property_address_state": "TX",
  "property_address_zip_full": "77380",
  "property_address_zip": "77380",
  "property_address_country": "US",
  "property_address_county": "Montgomery County",
  "property_neighborhood_address": "Grogan's Mill",
  "property_address_latitude": "30.1401216",
  "property_address_longitude": "-95.4514889",
  "property_email": "neuhauswoodlands@galleryresidential.com",
  "property_phone": "(281) 271-5569",
  "property_call_tracking_phone": "(346) 472-5946",
  "property_company_name": "Gallery Residential",
  "property_company_url": "https://www.galleryresidential.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "<p><strong>Modern Woodlands living, tucked into Grogan’s Mill.</strong> Explore polished one-, two-, and three-bedroom homes with elevated finishes, everyday conveniences, and smoke-free, pet-friendly comfort—then schedule your tour of Neuhaus today.</p>",
  "property_long_description": "Discover modern living at Neuhaus Apartments in Spring, TX. Our luxury pet-friendly apartments feature spacious 1, 2, and 3-bedroom floor plans in the heart of Grogan's Mill. Each home boasts premium finishes like granite countertops, stainless steel appliances, hardwood-style flooring, and in-unit washer and dryers. Enjoy world-class amenities including a resort-style pool, a state-of-the-art fitness center with a yoga studio, and a dog park. Located near The Woodlands, we offer easy access to top-tier dining, shopping, and parks. Experience the perfect blend of sophistication and comfort.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1a829-3e3c-728f-b63b-4df6f57e5db9.webp",
  "property_featured_image_media": {
    "alt_text": "Lobby seating area with orange chairs and coffee tables.",
    "public_id": "01a1a829-3e3c-728f-b63b-4df6f57e5db9",
    "storage_key": "property/6767906449167905/01a1a829-3e3c-728f-b63b-4df6f57e5db9.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "225",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": "47",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.07142857142857",
  "property_admin_fee": "200",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit: $500.00 (refundable).",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "1",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 3 pets per apartment.",
  "property_pet_policy_description": "Pet fee: $1.00 (non-refundable). Monthly pet rent: $30.00/month.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://neuhaus.prospectportal.com/spring/neuhaus",
  "property_resident_portal_url": "https://neuhaus.residentportal.com/auth",
  "property_apply_now_url": "https://neuhaus.prospectportal.com/Apartments/module/application_authentication/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17956-dbc5-771d-a608-ab8f7c7e5409.webp",
  "property_primary_logo_media": {
    "alt_text": "Property Logo",
    "public_id": "01a17956-dbc5-771d-a608-ab8f7c7e5409",
    "storage_key": "property/6767906449167905/01a17956-dbc5-771d-a608-ab8f7c7e5409.webp",
    "width": 680,
    "height": 690
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e27-c09c-7401-b4bf-ad213d0730d6.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a18e27-c09c-7401-b4bf-ad213d0730d6",
    "storage_key": "property/6767906449167905/01a18e27-c09c-7401-b4bf-ad213d0730d6.webp",
    "width": 680,
    "height": 690
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e27-b396-7119-ad80-e5ad35be0650.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a18e27-b396-7119-ad80-e5ad35be0650",
    "storage_key": "property/6767906449167905/01a18e27-b396-7119-ad80-e5ad35be0650.webp",
    "width": 680,
    "height": 690
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162393/019f4270-24f6-709b-b2c5-c205bf400083.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162393/019f426f-bfed-731a-a27d-d31038c4cea2.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#2F2E31",
  "property_secondary_color": "#4C616D",
  "property_font_color": null,
  "property_color_4": "#676C60",
  "property_color_3": "#A36D4B",
  "property_color_5": "#FFFFFF",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "629 - 1507",
  "property_sqft_min": "629",
  "property_sqft_max": "1507",
  "property_price_range": "$1312 - $2351",
  "property_price_min": "1312",
  "property_price_max": "2351",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=100095508875371",
  "property_instagram_url": "https://www.instagram.com/liveneuhaus/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJsfcS_T03R4YR_0EZAURoR7k",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": "https://www.tiktok.com/@liveneuhaus",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Neuhaus (Woodlands)",
  "property_home_romance_title": "Experience the Joy of Living in Your Dream Home",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, built right in.</strong> Neuhaus pairs polished apartment finishes with amenities that keep the day moving—from elevator access, air-conditioned corridors, and refrigerated package lockers to a grab-and-go market, coffee bar, wireless printing, and free bike storage. Recharge in the fitness center, yoga and meditation studio, resident lounge, or outdoor gaming and grilling spaces, then come home to granite countertops, stainless steel appliances, full-size washer/dryer, walk-in closets, and hardwood-style LVT flooring.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to live your way.</strong> Choose from one-, two-, and three-bedroom apartments in Spring with polished finishes like granite countertops, stainless steel appliances, full-size washer/dryer, walk-in closets, USB outlets, and hardwood-style LVT flooring. Select layouts add flex den/office space, large island kitchens, private balconies, oversized yards, walk-in showers, or attached building garages—so it’s easy to find the space that fits the day.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a sharper look at Neuhaus.</strong> Preview bright interiors with granite-topped kitchens, stainless steel appliances, wide-plank LVT flooring, and outdoor space with select balconies or yards. Then picture the wider scene: a resort-style pool, coffee bar, entertainment lounge, fitness center, and yoga studio. Browse the gallery, then explore <a href=\"/virtual-tours\">virtual tours</a> for the next view.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Grogan’s Mill puts The Woodlands in easy reach.</strong> From Neuhaus, bike toward Mill Bend Trail, browse The Woodlands Farmers Market, or unwind at Sawmill Park and nearby nature paths. Town Center dining and retail are close by, while Sawdust Park &amp; Ride connects weekday routes into Houston. Back home, <strong>bike storage, outdoor spaces, and pet-friendly conveniences</strong> make it easy to enjoy the neighborhood, then reset in a modern apartment.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have great things to say about Neuhaus.</strong><br>Reviews highlight a welcoming, well-kept community in Grogan’s Mill, with praise for a responsive leasing team and a move-in experience described as smooth and stress free. Residents also call out the clean pool, quiet setting, convenient location, and neighborly atmosphere—details that make everyday life here stand out. Read the full reviews for more firsthand perspectives.</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the village outside your door.</strong> In Grogan’s Mill, days can move from shaded pathways to neighborhood errands without losing The Woodlands’ calm, green feel. Bike toward Mill Bend Trail, browse Saturday vendors at The Woodlands Farmers Market at Grogan’s Mill, or spend a fresh-air break at Sawmill Park and nearby nature paths.</p><p>When plans call for more, you’re close to the restaurants and retail of Town Center, while Sawdust Park &amp; Ride offers a weekday connection to major Houston job centers. Back at Neuhaus, <a href=\"/amenities\">bike storage, outdoor spaces, and pet-friendly conveniences</a> help the neighborhood feel easy to enjoy—then your modern apartment is ready for a quiet reset.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living, without the extra effort.</strong> At Neuhaus, the details are designed to make your day run smoother—from elevator access, air-conditioned corridors, and package lockers with refrigerated storage to a grab-and-go market, coffee bar, wireless printing, and free bike storage. When it is time to reset, move between the fitness center, yoga and meditation studio, resident lounge, and outdoor gaming and grilling spaces, then see how it all comes together in the <a href=\"/gallery\">photo gallery</a>.</p><p>Inside your apartment, polished finishes keep the look clean and current: granite countertops, stainless steel appliances, farmhouse-style undermount sinks, USB outlets, full-size washer/dryer, walk-in closets, and hardwood-style LVT flooring. Select homes add features like flex den space, oversized yards, walk-in showers, large island kitchens, or attached garages—details you can compare on the <a href=\"/floor-plans\">floor plans</a> page.</p>",
  "property_applynow_blurb": "<p><strong>Start your Neuhaus application online.</strong> Choose a polished one-, two-, or three-bedroom home with granite countertops, stainless steel appliances, hardwood-style LVT flooring, walk-in closets, and in-home washer/dryer. With pet-friendly, smoke-free living in Grogan’s Mill, Neuhaus makes it easy to feel settled from day one.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact the Neuhaus leasing team for details on available floor plans, elevated finishes, pet-friendly living, or getting directions to our Grogan’s Mill location. We’ll help you take the next step toward modern Woodlands living.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Neuhaus?</strong> Start here for quick answers about the community, leasing, amenities, pet-friendly living, and what to expect at this smoke-free Grogan’s Mill address. If you don’t see what you need, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong> Neuhaus gives you a focused collection of one-, two-, and three-bedroom apartment homes in Spring, from streamlined one-bedrooms to roomier layouts with extra space to spread out. As you compare floor plans, look for the details that make each option feel finished: granite countertops, stainless steel appliances, full-size washer/dryer, walk-in closets, USB outlets, ceiling fans, and hardwood-style LVT flooring.</p><p>Select homes add the upgrades that can change how you use your space, including flex den/office areas, large island kitchens, private balconies, oversized yards, walk-in showers, or attached building garages. Browse current availability, pricing, and move-in dates below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>See the style before you step inside.</strong> Browse the Neuhaus photo gallery for a closer look at bright apartment interiors, clean-lined kitchens with granite countertops and stainless steel appliances, wide-plank LVT flooring, and balconies or yards that extend the view outdoors.</p><p>Then move through the community in scenes: a resort-style pool made for sunny afternoons, a lounge with gaming and entertainment zones, a coffee bar for quick pauses, and wellness spaces that include a fitness center and yoga studio. From polished finishes to inviting shared areas, these photos show how Neuhaus brings modern apartment living into focus in The Woodlands. Ready to compare layouts or picture the flow in motion? Explore <a href=\"/floor-plans\">available floor plans</a> or view <a href=\"/virtual-tours\">virtual tours</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Neuhaus from the map.</strong> See available apartments in Grogan’s Mill, then scan the surrounding Woodlands area for nearby everyday essentials, parks, pathways, and quick I-45 access—all from one easy, interactive view.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living should feel easy, not added on.</strong> At Neuhaus, cats and dogs have room in the routine, with a dedicated <a href=\"/amenities\">pet park with a drinking fountain</a> for quick outdoor breaks and a smoke-free setting that keeps shared spaces feeling fresh.</p><p>After a walk through the Grogan’s Mill area, come home to interiors made for everyday clean-up and comfort, including luxury vinyl plank flooring, full-size washers and dryers, and select layouts with private oversized yards. With up to three pets welcome per apartment, you can choose the space that fits your household, then confirm current policy details with the leasing team or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the pet-friendly features in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share Neuhaus living.</strong> If you love the polished finishes, pet-friendly setting, wooded-area convenience, and easy everyday spaces at Neuhaus, invite a friend to experience it too. Send a referral and help them find their next home in Grogan’s Mill.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Neuhaus.</strong><br>Keep everyday living simple in your Grogan’s Mill home base. Log in to pay rent, submit maintenance requests, and manage your account—so you can get back to enjoying the polished comfort and wooded-area convenience of Neuhaus.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend Neuhaus.</strong><br>Reviews point to a welcoming, well-kept apartment community in Grogan’s Mill, with frequent praise for the leasing team’s responsiveness and care. Residents call the move-in experience “smooth, professional, and stress free,” and highlight team members like Kristin, Alexander, and Britni for answering questions, sharing helpful details, and making the process easy from start to finish.</p><p>You’ll also see appreciation for the clean pool, quiet setting, great location, and neighborly atmosphere—one resident summed it up as an “awesome community.” Browse the reviews below for firsthand perspectives on everyday life at Neuhaus.</p>",
  "property_created_at": "1793037020781",
  "property_scheduletour_blurb": "<p><strong>See Neuhaus up close.</strong> Tour one-, two-, and three-bedroom layouts with granite countertops, stainless steel appliances, hardwood-style LVT flooring, walk-in closets, and private balconies. From polished interiors to easy community spaces, an in-person visit brings the details into focus. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Neuhaus leasing team will be in touch soon. In the meantime, picture modern Woodlands living in Grogan’s Mill, with polished apartment finishes, smoke-free comfort, pet-friendly spaces, and everyday conveniences designed to keep life moving with ease.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Neuhaus (Woodlands)",
  "property_seo_title_home": "Neuhaus (Woodlands) |  Apartments in Spring, TX",
  "property_seo_description_home": "Experience luxury living at Neuhaus in Spring, TX. Choose from 1, 2, or 3-bedroom plans with modern amenities and outdoor spaces. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Spring, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Neuhaus in Spring, TX! From cozy one-bedroom to spacious three-bedroom layouts, browse our unique floor plans today.",
  "property_seo_title_amenities": "Amenities | Spring, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience elevated living at Neuhaus (Woodlands) in Spring, TX. Enjoy spacious apartments, luxury amenities, and a vibrant community. Your dream home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Spring, TX",
  "property_seo_description_gallery": "Experience luxury living at Neuhaus in Spring, TX. Modern amenities, spacious floor plans, and a vibrant community await. Picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Neuhaus (Woodlands) Apartments",
  "property_seo_description_virtualtours": "Discover modern living at Neuhaus, Spring, TX! Choose from spacious 1-3 bedroom apartments. Take a virtual tour today to find your home!",
  "property_seo_title_interactivemap": "Interactive Map | Neuhaus (Woodlands) Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Neuhaus in Spring, TX! Choose from stylish 1-3 bedroom apartments with premium amenities. Check our interactive map for details!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Spring, TX",
  "property_seo_description_neighborhood": "Uncover the charm of Spring, TX at Neuhaus. Enjoy diverse floor plans and vibrant local spots just steps away. Your new adventure starts here!",
  "property_seo_title_contact": "Contact Us | Neuhaus (Woodlands)",
  "property_seo_description_contact": "Connect with our friendly leasing team at Neuhaus in Spring, TX, to find your perfect home from cozy one-bedrooms to spacious three-bedrooms!",
  "property_seo_title_faqs": "FAQs | Apartments in Spring, TX",
  "property_seo_description_faqs": "Find answers to your burning questions at Neuhaus Woodlands! From luxury amenities to floor plans, explore our FAQs for insights into your future home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Spring, TX",
  "property_seo_description_reviews": "At Neuhaus in Spring, TX, residents enjoy luxury living with top amenities, modern designs, and vibrant community spaces. Check out their experiences today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Spring, TX",
  "property_seo_description_applynow": "Discover luxury living at Neuhaus in Spring, TX! Modern amenities and spacious floor plans await. Apply now to elevate your lifestyle!",
  "property_seo_title_residentaccess": "Resident Access | Neuhaus (Woodlands)",
  "property_seo_description_residentaccess": "Manage your life at Neuhaus Woodlands! Log in to your resident portal for rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Neuhaus (Woodlands)",
  "property_seo_description_referafriend": "Refer a friend to Neuhaus in Spring, TX! Great friends make great neighbors—share the joy and enjoy exclusive perks together in our vibrant community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Neuhaus (Woodlands)",
  "property_seo_description_scheduletour": "Experience the charm of Neuhaus in Spring, TX. Schedule a tour today and uncover your dream apartment nestled in a vibrant community. Your new home awaits!",
  "property_seo_title_privacy": "Privacy Policy | Neuhaus (Woodlands)",
  "property_seo_description_privacy": "At Neuhaus in Spring, TX, your privacy matters. Uncover how we protect your personal information and create a safe community. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Neuhaus (Woodlands)",
  "property_seo_description_accessibility": "At Neuhaus in Spring, TX, we prioritize digital inclusion. Our accessibility statement ensures everyone can enjoy a seamless online experience. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Neuhaus (Woodlands)",
  "property_seo_description_sitemap": "Navigate your way through Neuhaus in Spring, TX! Our sitemap makes finding your perfect apartment a breeze. Discover a community tailored for you!",
  "property_seo_title_thankyou": "Thank You | Neuhaus (Woodlands)",
  "property_seo_description_thankyou": "Thank you for reaching out to Neuhaus in Spring, TX! Our team is excited to connect with you soon about your future home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Spring, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793731018617",
  "amenities": [
    {
      "id": "ec_33b49a148edca90a2cc55ed4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:1020",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "true",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19b55564fad54522d2fe9a87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:1045",
      "title": "Private Balconies",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d7173608518800c71923674b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:1423",
      "title": "Luxury Vinyl Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "true",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e59ba094505b9637e41b9f83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:1660",
      "title": "Walk-in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc9e90a221a584426721ac23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:1662",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "true",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43fb2c501e67a0c815025142",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:1675",
      "title": "9' Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc46a32795da77eb81119efa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:1729",
      "title": "Elevator Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d8c4f815cdc8cbb776ed0ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:2340",
      "title": "State-of-the-Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e459695e1bd966c83b4dea6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:4221",
      "title": "Ceiling Fans in All Bedrooms and Living Rooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d57d3a0a9b97341166a50411",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:5667",
      "title": "Kitchen island",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "true",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0fbd9c2e7dd5a60dabafc42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:11386",
      "title": "Stainless Steel Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3be4b112685e10fa90557390",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15347",
      "title": "Full-size washer/dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "true",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4db1d35a5409d9e63dfb61f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15356",
      "title": "Farmhouse Style Undermount Sinks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5fb4576c22d959f4d5ebce7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15357",
      "title": "Modern Faucets with Pull-out Sprayer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2bc5be6b589292cdee4685bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15413",
      "title": "Attached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "true",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_966f3e4251beb0d4f86e0c59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15464",
      "title": "Coffee and Refreshment Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6659e4507cdfbf8d41740444",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15575",
      "title": "Tile Shower and Tub Surrounds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb30fb712631a542c32fa158",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15814",
      "title": "USB Outlets",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "true",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_748697449355397177ae1a1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15940",
      "title": "Flex Den/Office Space*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d70b762127428838f33b1f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15943",
      "title": "Grab-and-Go Market",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e050c84bacc05ca031ff9796",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15947",
      "title": "Resident Lounge with Gaming and Entertainment Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22cf295327b81e6149ad9f87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15952",
      "title": "Air Conditioned Corridors",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44431294fd8993f6c79ce9b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15954",
      "title": "Smoke Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ba654ffd1f0f84bcff5f457",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15973",
      "title": "Modern ceiling fans with light kits",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b694fd352c6837c0f284a5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15978",
      "title": "Private, Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8ff1c19d3091d2f4fa3437d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:15983",
      "title": "Wireless printing with PrintWithMe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3820db4aa2d51b2fde01a73c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16004",
      "title": "10' Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79f496fe4182b9eba10ade56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16005",
      "title": "Hardwood Style LVT flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bbb7a9ce4e0cbc63d1c42c6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16006",
      "title": "Walk-in Showers*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb8f70afba3ceced515b7ea6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16007",
      "title": "Contemporary Lighting Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5b69cf6ad1c4b13e1f1fcaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16008",
      "title": "Large Island Kitchens*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f172aab8571b237073cfb907",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16009",
      "title": "Private Oversized Yards*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca54b63b792a82c6cfeac8f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16010",
      "title": "Attached Building Garages*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b186692f24a9c379865560d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16011",
      "title": "Outdoor Entertainment Space with Outdoor Gaming and Grilling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a4ae2d9623390092251f23a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16012",
      "title": "Resident Mail Lounge and Package lockers with Refrigerated lockers for food deliveries",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2df73a06415488db81a0ee83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16013",
      "title": "Free Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d62d63e048bbdff80d69aa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16014",
      "title": "Resident Storage Space Available*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86a2d65acf9d46281bb83e1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16015",
      "title": "Yoga and Meditation Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc7390c7c29a1015664594b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16016",
      "title": "Pet Park with Pet Drinking Fountain",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e265abbb93c62ffca708e36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "community:16017",
      "title": "Covered Carports Available*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_c8654189-4cab-48cc-acd6-989b6918fe81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e99-6e1e-7498-a29e-589d04b41d4d.webp",
      "image_media": {
        "alt_text": "Exterior of the Neuhaus apartment building with a 'Now Open' banner.",
        "public_id": "01a19e99-6e1e-7498-a29e-589d04b41d4d",
        "storage_key": "property/6767906449167905/01a19e99-6e1e-7498-a29e-589d04b41d4d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The modern exterior of the Neuhaus apartment building, featuring blue and gray facades, private balconies, and a 'Now Open' banner. Includes a parking lot and entrance gate.",
      "link": "",
      "alt_text": "Exterior of the Neuhaus apartment building with a 'Now Open' banner.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_db0c05a5-ee67-4438-b8b8-2b93637957e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e99-2e7a-713b-993f-d84cd4717a72.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, shower, and bathtub, connected to a bedroom.",
        "public_id": "01a19e99-2e7a-713b-993f-d84cd4717a72",
        "storage_key": "property/6767906449167905/01a19e99-2e7a-713b-993f-d84cd4717a72.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the luxury of this modern apartment bathroom, featuring a spacious vanity, sleek fixtures, and a relaxing bathtub. The adjoining bedroom offers a tranquil retreat.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, shower, and bathtub, connected to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_27ffe5f1-7121-43e3-91f3-2f2b7ca152d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e99-1465-73ad-bca6-6a93e8c8d95b.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with cardio machines, weight machines, and free weights.",
        "public_id": "01a19e99-1465-73ad-bca6-6a93e8c8d95b",
        "storage_key": "property/6767906449167905/01a19e99-1465-73ad-bca6-6a93e8c8d95b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with cardio and weight training equipment.",
      "link": "",
      "alt_text": "Modern apartment gym with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_90821d0c-acfd-46f4-90d9-0fb64e91eddb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e99-0b42-779e-b729-88731c7be26b.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with grilling station, lounge chairs, and seating areas.",
        "public_id": "01a19e99-0b42-779e-b729-88731c7be26b",
        "storage_key": "property/6767906449167905/01a19e99-0b42-779e-b729-88731c7be26b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the resort-style amenities at our community, featuring a sparkling pool, outdoor grilling stations, and comfortable seating areas for relaxation and entertainment.",
      "link": "",
      "alt_text": "Outdoor pool area with grilling station, lounge chairs, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_40a3663e-26b9-4d2f-b77c-62a9a5e7bc57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e99-036d-7084-a0a2-d80f964a89cc.webp",
      "image_media": {
        "alt_text": "Stylish communal kitchen area with bar seating and modern decor.",
        "public_id": "01a19e99-036d-7084-a0a2-d80f964a89cc",
        "storage_key": "property/6767906449167905/01a19e99-036d-7084-a0a2-d80f964a89cc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in our chic communal kitchen, perfect for entertaining or enjoying a casual meal together.",
      "link": "",
      "alt_text": "Stylish communal kitchen area with bar seating and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9fa7a747-9fa0-4adc-93ef-d2c763edc3de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e99-0001-7029-b9f5-a977450148c7.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, vanity, and ample storage.",
        "public_id": "01a19e99-0001-7029-b9f5-a977450148c7",
        "storage_key": "property/6767906449167905/01a19e99-0001-7029-b9f5-a977450148c7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed bathroom, featuring a spacious bathtub, modern vanity, and convenient storage solutions.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, vanity, and ample storage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d6b26785-5f92-4f7b-b5d0-7c7157922b86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e98-dac5-70dc-973a-b54644f86672.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa, armchair, floor lamps, and abstract art.",
        "public_id": "01a19e98-dac5-70dc-973a-b54644f86672",
        "storage_key": "property/6767906449167905/01a19e98-dac5-70dc-973a-b54644f86672.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy and stylish living room featuring a comfortable blue sofa, accent armchair, elegant floor lamps, and modern abstract wall art, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with blue sofa, armchair, floor lamps, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_32a3d10c-9a38-46e8-b629-54efad661084",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e98-7fb2-7012-8d62-5401c257fd04.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "01a19e98-7fb2-7012-8d62-5401c257fd04",
        "storage_key": "property/6767906449167905/01a19e98-7fb2-7012-8d62-5401c257fd04.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover your dream kitchen featuring sleek white cabinetry, durable granite countertops, and state-of-the-art stainless steel appliances. Perfect for culinary adventures.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8213e4ab-2b5f-408b-873f-a4226e13bc97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e98-2ae9-761e-997d-4e46af8be41a.webp",
      "image_media": {
        "alt_text": "Aerial view of a large apartment complex with surrounding buildings and a pond.",
        "public_id": "01a19e98-2ae9-761e-997d-4e46af8be41a",
        "storage_key": "property/6767906449167905/01a19e98-2ae9-761e-997d-4e46af8be41a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "An aerial view of a modern apartment complex, showcasing its architecture, surrounding amenities, and landscaped grounds.",
      "link": "",
      "alt_text": "Aerial view of a large apartment complex with surrounding buildings and a pond.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4e5e6fc8-395d-42cc-83f9-c48bf6fe82d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e98-2123-74ba-8cee-85010a1dd9f8.webp",
      "image_media": {
        "alt_text": "Arcade game machines in a community lounge area.",
        "public_id": "01a19e98-2123-74ba-8cee-85010a1dd9f8",
        "storage_key": "property/6767906449167905/01a19e98-2123-74ba-8cee-85010a1dd9f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy some fun with vintage arcade games available in the community lounge.",
      "link": "",
      "alt_text": "Arcade game machines in a community lounge area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e289c629-cc99-4706-9dfb-c77babb5eb69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e97-c15f-764f-ab40-65aa8261e1cb.webp",
      "image_media": {
        "alt_text": "Modern apartment complex gym with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "01a19e97-c15f-764f-ab40-65aa8261e1cb",
        "storage_key": "property/6767906449167905/01a19e97-c15f-764f-ab40-65aa8261e1cb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, strength training machines, and free weights to help you achieve your health goals.",
      "link": "",
      "alt_text": "Modern apartment complex gym with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0da782df-e517-4e4f-90e8-d67ca9ff2c39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e97-885d-71fd-a9a0-33be9152eda1.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with granite countertop and stainless steel faucet, opens to a kitchen area.",
        "public_id": "01a19e97-885d-71fd-a9a0-33be9152eda1",
        "storage_key": "property/6767906449167905/01a19e97-885d-71fd-a9a0-33be9152eda1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover sophisticated living in our apartments, featuring a sleek bathroom vanity with granite countertops and a modern kitchen.",
      "link": "",
      "alt_text": "Modern bathroom vanity with granite countertop and stainless steel faucet, opens to a kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_374badff-7014-4b87-ac8f-9185ae4174e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e97-8687-77de-a8ff-1dd546195b40.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops and stainless steel appliances opens to a living area.",
        "public_id": "01a19e97-8687-77de-a8ff-1dd546195b40",
        "storage_key": "property/6767906449167905/01a19e97-8687-77de-a8ff-1dd546195b40.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a stylish kitchen with granite countertops and stainless steel appliances, perfect for cooking and entertaining. Opens seamlessly into a comfortable living space.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops and stainless steel appliances opens to a living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_76f397fe-48ee-48ef-8527-e2f0def6214e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e97-7b06-7263-b153-3b0061dd7d47.webp",
      "image_media": {
        "alt_text": "Elevator bank with blue tile accents and frosted glass doors leading to a common area.",
        "public_id": "01a19e97-7b06-7263-b153-3b0061dd7d47",
        "storage_key": "property/6767906449167905/01a19e97-7b06-7263-b153-3b0061dd7d47.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern elevator bank featuring sleek stainless steel doors and vibrant blue tiled walls, leading to a welcoming common area with frosted glass doors.",
      "link": "",
      "alt_text": "Elevator bank with blue tile accents and frosted glass doors leading to a common area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_44248c14-b74a-4c0a-94ee-c11cae09716f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e97-7afc-744a-99e8-9c3e9cbcd1f4.webp",
      "image_media": {
        "alt_text": "Kitchen island with sink and granite countertops, showing washer and dryer, living room, and bedroom in background.",
        "public_id": "01a19e97-7afc-744a-99e8-9c3e9cbcd1f4",
        "storage_key": "property/6767906449167905/01a19e97-7afc-744a-99e8-9c3e9cbcd1f4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring a granite-topped island with a sink, stainless steel appliances including a stacked washer and dryer, and a glimpse into the living room and bedroom.",
      "link": "",
      "alt_text": "Kitchen island with sink and granite countertops, showing washer and dryer, living room, and bedroom in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d97e0272-5fc9-4c89-9b60-7ae3dd7bb1b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e97-7bb3-76af-9945-a9341aa791b6.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with multiple levels and balconies.",
        "public_id": "01a19e97-7bb3-76af-9945-a9341aa791b6",
        "storage_key": "property/6767906449167905/01a19e97-7bb3-76af-9945-a9341aa791b6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover luxury living in this stunning apartment community, featuring a modern exterior design and convenient amenities.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with multiple levels and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d5deaa4f-fc71-47ba-a708-979970e22d66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e97-6c74-7688-8295-a8f0032f38e5.webp",
      "image_media": {
        "alt_text": "Lounge area with blue sofas, modern coffee tables, and a stone accent wall with a television.",
        "public_id": "01a19e97-6c74-7688-8295-a8f0032f38e5",
        "storage_key": "property/6767906449167905/01a19e97-6c74-7688-8295-a8f0032f38e5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge area, featuring comfortable seating, contemporary decor, and a large screen TV for your entertainment.",
      "link": "",
      "alt_text": "Lounge area with blue sofas, modern coffee tables, and a stone accent wall with a television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67df8146-692a-4d20-9d15-309731bab9b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e97-55b2-72ff-9d6a-ff2b142f891d.webp",
      "image_media": {
        "alt_text": "Coffee bar with premium coffee maker, assorted coffee pods, snacks, and decorative letter N.",
        "public_id": "01a19e97-55b2-72ff-9d6a-ff2b142f891d",
        "storage_key": "property/6767906449167905/01a19e97-55b2-72ff-9d6a-ff2b142f891d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy complimentary premium coffee and snacks at our resident coffee bar, featuring a state-of-the-art coffee maker and a selection of treats.",
      "link": "",
      "alt_text": "Coffee bar with premium coffee maker, assorted coffee pods, snacks, and decorative letter N.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b6fb9eb-36c2-4035-89ca-c74f94137693",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e97-35ad-72f7-b2c5-95878faf2116.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with surrounding trees and a clear sky.",
        "public_id": "01a19e97-35ad-72f7-b2c5-95878faf2116",
        "storage_key": "property/6767906449167905/01a19e97-35ad-72f7-b2c5-95878faf2116.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "An aerial perspective showcasing the apartment complex nestled amidst lush greenery, offering a glimpse of its modern architecture and tranquil surroundings under a bright, cloudy sky.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with surrounding trees and a clear sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1b46b799-db64-45a9-b0e1-d2f15715324b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e97-239e-70d1-b4d5-2f063788c5b6.webp",
      "image_media": {
        "alt_text": "Package lockers and mailboxes in apartment building lobby",
        "public_id": "01a19e97-239e-70d1-b4d5-2f063788c5b6",
        "storage_key": "property/6767906449167905/01a19e97-239e-70d1-b4d5-2f063788c5b6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure package lockers and traditional mailboxes are conveniently located in the building's modern and well-lit lobby, providing easy access for residents.",
      "link": "",
      "alt_text": "Package lockers and mailboxes in apartment building lobby",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1937eb53-cbea-4b93-8c6a-bb2cfad25c60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e96-6045-75db-857b-29ae85833e1e.webp",
      "image_media": {
        "alt_text": "Queen size bed with gray and white bedding, dark blue throw, and decorative pillows. Bedside table with lamp to the left.",
        "public_id": "01a19e96-6045-75db-857b-29ae85833e1e",
        "storage_key": "property/6767906449167905/01a19e96-6045-75db-857b-29ae85833e1e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed, plush bedding, and stylish decor. A large window provides ample natural light.",
      "link": "",
      "alt_text": "Queen size bed with gray and white bedding, dark blue throw, and decorative pillows. Bedside table with lamp to the left.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_99de0f36-4406-4f4a-a8b9-5ecca683d91a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e96-5b6c-70dd-8295-a1fc52a7238c.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-size bed, plush blue bedding, and decorative pillows.",
        "public_id": "01a19e96-5b6c-70dd-8295-a1fc52a7238c",
        "storage_key": "property/6767906449167905/01a19e96-5b6c-70dd-8295-a1fc52a7238c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this primary bedroom, featuring a luxurious king-size bed with elegant blue bedding and stylish decorative pillows for a restful retreat.",
      "link": "",
      "alt_text": "Primary bedroom with a king-size bed, plush blue bedding, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3f42cdde-4a8a-40d9-88bc-c2a0099073d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e96-58a4-7233-afdc-6d4ccd44a2f0.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a ceiling fan.",
        "public_id": "01a19e96-58a4-7233-afdc-6d4ccd44a2f0",
        "storage_key": "property/6767906449167905/01a19e96-58a4-7233-afdc-6d4ccd44a2f0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this serene bedroom, featuring a comfortable queen-size bed, stylish nightstands, and a refreshing ceiling fan for optimal comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0241d2d9-c7d8-4b49-9871-1f00ae26a0ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e96-4593-763a-8bb4-ac9d27ad78d4.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by buildings and landscaping.",
        "public_id": "01a19e96-4593-763a-8bb4-ac9d27ad78d4",
        "storage_key": "property/6767906449167905/01a19e96-4593-763a-8bb4-ac9d27ad78d4.webp",
        "width": 3072,
        "height": 1967
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Perfect for relaxation and soaking up the sun.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by buildings and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5db45d3c-a860-45da-be4c-c20b809ac2dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e96-2aad-751d-9718-09332d3138ef.webp",
      "image_media": {
        "alt_text": "Communal dining table with blue chairs in a modern hallway.",
        "public_id": "01a19e96-2aad-751d-9718-09332d3138ef",
        "storage_key": "property/6767906449167905/01a19e96-2aad-751d-9718-09332d3138ef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather around the large communal table, perfect for working or socializing. Enjoy the modern amenities and comfortable seating in this stylish community space.",
      "link": "",
      "alt_text": "Communal dining table with blue chairs in a modern hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3b433318-8821-43e9-bc6d-16ed7aa18632",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e96-2aa7-7671-b348-a62803760a15.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with granite countertops, bar stools, and grills.",
        "public_id": "01a19e96-2aa7-7671-b348-a62803760a15",
        "storage_key": "property/6767906449167905/01a19e96-2aa7-7671-b348-a62803760a15.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our community grilling stations, complete with comfortable bar seating and modern appliances.",
      "link": "",
      "alt_text": "Outdoor grilling area with granite countertops, bar stools, and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b716ddcb-9381-4fb4-9ac7-8d9925fbce59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e96-21be-7328-98ac-a85c5e32abf8.webp",
      "image_media": {
        "alt_text": "Fitness center gym with medicine balls, free weights, treadmills, and mirrors.",
        "public_id": "01a19e96-21be-7328-98ac-a85c5e32abf8",
        "storage_key": "property/6767906449167905/01a19e96-21be-7328-98ac-a85c5e32abf8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, free weights, and functional training equipment.",
      "link": "",
      "alt_text": "Fitness center gym with medicine balls, free weights, treadmills, and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c398e240-ce97-469e-a795-bd416a2483a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e96-1ee9-7588-a0b9-6f16c48e42b7.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a19e96-1ee9-7588-a0b9-6f16c48e42b7",
        "storage_key": "property/6767906449167905/01a19e96-1ee9-7588-a0b9-6f16c48e42b7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and lush palm trees. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and palm trees at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78eb6ce9-b5bf-470b-a5e5-2ce921593d20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e96-1983-771f-a6e9-579efd0ff40f.webp",
      "image_media": {
        "alt_text": "Living room with a beige sofa, accent chair, coffee table, and large window with blinds.",
        "public_id": "01a19e96-1983-771f-a6e9-579efd0ff40f",
        "storage_key": "property/6767906449167905/01a19e96-1983-771f-a6e9-579efd0ff40f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable sofa, stylish accent chair, and a modern coffee table, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a beige sofa, accent chair, coffee table, and large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9951797b-2b6f-4627-8ac9-56d5c9314161",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a19e96-1894-7288-a58c-a42866c9656d.webp",
      "image_media": {
        "alt_text": "Lobby seating area with orange chairs, coffee tables, and modern decor.",
        "public_id": "01a19e96-1894-7288-a58c-a42866c9656d",
        "storage_key": "property/6767906449167905/01a19e96-1894-7288-a58c-a42866c9656d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in the stylish lobby seating area, featuring plush orange chairs and modern art, perfect for unwinding or meeting guests.",
      "link": "",
      "alt_text": "Lobby seating area with orange chairs, coffee tables, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e1caf98e-ea04-4b3d-93f5-2ac196335a95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "First Cup Coffee Co",
      "poi_type": "Restaurants",
      "poi_address": "26403 Oak Ridge Dr, Spring, TX 77380, USA",
      "poi_short_description": "Spacious coffee shop featuring a garden with a play area and private meeting spaces.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-ee0c-70e9-92cf-201ec0a17b53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-ee0c-70e9-92cf-201ec0a17b53",
        "storage_key": "property/6767906449167905/01a18e28-ee0c-70e9-92cf-201ec0a17b53.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.firstcup.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3825393101541017295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-cup-coffee-co",
      "poi_latitude": "30.144817000000003",
      "poi_longitude": "-95.4493412",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-510-4291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-de6a-741e-9bd1-038372736337.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6a-741e-9bd1-038372736337",
        "storage_key": "property/6767906449167905/01a17965-de6a-741e-9bd1-038372736337.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ9xEbD4E3R4YRzwaVD8KGFjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_0f53bf58-a15d-4291-805c-837e35455e6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Dosey Doe - The Big Barn",
      "poi_type": "Entertainment",
      "poi_address": "25911 Interstate 45 N, Spring, TX 77380, USA",
      "poi_short_description": "A vintage 1840s barn has been transformed into a multilevel music venue with fixed-price dinners.",
      "poi_long_description": "A vintage 1840s barn has been transformed into a multilevel music venue with fixed-price dinners.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-e9bc-7349-8772-9b205dc4b612.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-e9bc-7349-8772-9b205dc4b612",
        "storage_key": "property/6767906449167905/01a18e28-e9bc-7349-8772-9b205dc4b612.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.doseydoetickets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6853591421247063499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dosey-doe---the-big-barn",
      "poi_latitude": "30.138461099999997",
      "poi_longitude": "-95.4465389",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-367-3774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-de6b-72b4-8c33-d9dce04708f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6b-72b4-8c33-d9dce04708f9",
        "storage_key": "property/6767906449167905/01a17965-de6b-72b4-8c33-d9dce04708f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRd8ETE0R4YRy4UY8xXZHF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_0576b83e-3c5e-45f3-b6e0-87e1160a6bac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Kobe Japanese Grill and sushi",
      "poi_type": "Restaurants",
      "poi_address": "433 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "Family-friendly outfit featuring traditional sushi & hibachi options, plus weekday lunch specials.",
      "poi_long_description": "Family-friendly outfit featuring traditional sushi & hibachi options, plus weekday lunch specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17960-ad08-7475-b4b8-49614de0c36f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17960-ad08-7475-b4b8-49614de0c36f",
        "storage_key": "property/6767906449167905/01a17960-ad08-7475-b4b8-49614de0c36f.webp",
        "width": 1280,
        "height": 634
      },
      "poi_business_url": "http://www.kobewoodland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4957513092489420253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kobe-japanese-grill-and-sushi",
      "poi_latitude": "30.1251736",
      "poi_longitude": "-95.4488134",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-298-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbk4Mjs0R4YR3R0uP-SfzEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_ab161820-9d21-40d1-a16a-8f98cf39456d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "La Cocina de Roberto",
      "poi_type": "Restaurants",
      "poi_address": "3126 Sawdust Rd, The Woodlands, TX 77380, USA",
      "poi_short_description": "Casual, strip-mall stop offering Mexican grub such as tacos & carne asada plus margaritas & dessert.",
      "poi_long_description": "Casual, strip-mall stop offering Mexican grub such as tacos & carne asada plus margaritas & dessert.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17960-aaa0-71f8-9b5f-bd1604d1ad7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17960-aaa0-71f8-9b5f-bd1604d1ad7c",
        "storage_key": "property/6767906449167905/01a17960-aaa0-71f8-9b5f-bd1604d1ad7c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lacocinaderoberto.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3786570222054959330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-cocina-de-roberto",
      "poi_latitude": "30.133105900000004",
      "poi_longitude": "-95.4880345",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 832-299-6706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjRDUzfwzR4YR4mioCo6ZjDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f678d8e8-9789-428d-8844-7cd0a76b02d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Via Emilia Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10700 Kuykendahl Rd Ste F, The Woodlands, TX 77381, USA",
      "poi_short_description": "Upscale choice for hearty Italian fare such as handmade pastas & braised meats, plus wine options.",
      "poi_long_description": "Upscale choice for hearty Italian fare such as handmade pastas & braised meats, plus wine options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-ec79-763a-8bc0-6d3464702938.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-ec79-763a-8bc0-6d3464702938",
        "storage_key": "property/6767906449167905/01a18e28-ec79-763a-8bc0-6d3464702938.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.viaemilia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13980622060901552260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-emilia-italian-restaurant",
      "poi_latitude": "30.177896500000003",
      "poi_longitude": "-95.5348245",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-465-9555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWUx9bMxR4YRhNAGH7ElBcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_3ebaf390-90c1-47ec-848c-df67eaac2363",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Fielding's Local Kitchen + Bar",
      "poi_type": "Restaurants",
      "poi_address": "26400 Kuykendahl Rd, The Woodlands, TX 77375, USA",
      "poi_short_description": "Expansive New American eatery featuring dry-aged meats & a bar with a rotating list of craft brews.",
      "poi_long_description": "Expansive New American eatery featuring dry-aged meats & a bar with a rotating list of craft brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-ebb8-7504-a1c6-9efe3dda6ce2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-ebb8-7504-a1c6-9efe3dda6ce2",
        "storage_key": "property/6767906449167905/01a18e28-ebb8-7504-a1c6-9efe3dda6ce2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://fieldingslocal.com/?utm_campaign=gmb&utm_medium=maps&utm_source=google&utm_term=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1012042693659529980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fieldings-local-kitchen--bar",
      "poi_latitude": "30.1436756",
      "poi_longitude": "-95.5484448",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 281-351-2225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi3RXrPExR4YR_BIbxXd_Cw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e7dea130-b2d5-4337-abb0-ba6e89eb36e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Truluck's",
      "poi_type": "Restaurants",
      "poi_address": "1900 Hughes Landing Blvd Suite 600, The Woodlands, TX 77380, USA",
      "poi_short_description": "Upscale seafood & steak chain featuring half-price happy hours, a deep wine list & swanky surrounds.",
      "poi_long_description": "Upscale seafood & steak chain featuring half-price happy hours, a deep wine list & swanky surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-e9bd-7139-be7d-c97b10acdbf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-e9bd-7139-be7d-c97b10acdbf6",
        "storage_key": "property/6767906449167905/01a18e28-e9bd-7139-be7d-c97b10acdbf6.webp",
        "width": 864,
        "height": 575
      },
      "poi_business_url": "https://trulucks.com/locations/houston-woodlands-texas",
      "poi_directions_map_url": "https://maps.google.com/?cid=8600764676808325174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trulucks",
      "poi_latitude": "30.171263399999997",
      "poi_longitude": "-95.4722029",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-465-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_WWgCM42R4YRNjjjnecNXHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_50cba6a1-8b95-4659-842f-428b4ed4d8a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Perry's Steakhouse & Grille",
      "poi_type": "Restaurants",
      "poi_address": "6700 Woodlands Pkwy, The Woodlands, TX 77382, USA",
      "poi_short_description": "Upscale steakhouse & grill serving a menu including chops, seafood, wine & cocktails.",
      "poi_long_description": "Upscale steakhouse & grill serving a menu including chops, seafood, wine & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-e9c1-73bb-9bda-b64d65e777a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-e9c1-73bb-9bda-b64d65e777a4",
        "storage_key": "property/6767906449167905/01a18e28-e9c1-73bb-9bda-b64d65e777a4.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.perryssteakhouse.com/menu-locations/houston/the-woodlands/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5418009673383937232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perrys-steakhouse--grille",
      "poi_latitude": "30.182980599999993",
      "poi_longitude": "-95.5367002",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-362-0569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_RavZ0swR4YR0ASukxejMEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_8e2349fc-3d56-4dbf-8ce9-331fb2d6eb89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "The Republic Grille",
      "poi_type": "Restaurants",
      "poi_address": "4775 W Panther Creek Dr #490, The Woodlands, TX 77381, USA",
      "poi_short_description": "Rustic eatery with a Hill Country vibe offers Texas & Southern flavors, a full bar & a large patio.",
      "poi_long_description": "Rustic eatery with a Hill Country vibe offers Texas & Southern flavors, a full bar & a large patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-e985-776c-a311-aec0fda9ac9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-e985-776c-a311-aec0fda9ac9d",
        "storage_key": "property/6767906449167905/01a18e28-e985-776c-a311-aec0fda9ac9d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.therepublicgrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6100939259839975092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-republic-grille",
      "poi_latitude": "30.169236",
      "poi_longitude": "-95.504263",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-719-5895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpY7X8RYxR4YRtA7_wu7jqlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_26a222c0-8935-432d-bb45-a5e60c7af7a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "The Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "4526 Research Forest Dr, The Woodlands, TX 77381, USA",
      "poi_short_description": "Counter serve offering gourmet burgers, sandwiches & wines in a sleek, industrial-chic space.",
      "poi_long_description": "Counter serve offering gourmet burgers, sandwiches & wines in a sleek, industrial-chic space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-ef4e-716d-9dbf-85d7f7092899.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-ef4e-716d-9dbf-85d7f7092899",
        "storage_key": "property/6767906449167905/01a18e28-ef4e-716d-9dbf-85d7f7092899.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thekitcheninthewoodlands.com/start/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8019762569579044602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-kitchen",
      "poi_latitude": "30.1844754",
      "poi_longitude": "-95.4855634",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-203-5650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrVqgz9cwR4YR-p67BpHrS28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c0592477-3d0c-498b-b29c-b16b954a78ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "RC'S NYC PIZZA & PASTA - The Woodlands",
      "poi_type": "Restaurants",
      "poi_address": "501 Sawdust Rd Ste I, The Woodlands, TX 77380, USA",
      "poi_short_description": "Award-winning pizzeria offering authentic NYC-style pizza, Chicago deep dish, and pasta dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17960-e9fa-730e-9da8-90f3c5840379.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17960-e9fa-730e-9da8-90f3c5840379",
        "storage_key": "property/6767906449167905/01a17960-e9fa-730e-9da8-90f3c5840379.webp",
        "width": 1280,
        "height": 874
      },
      "poi_business_url": "https://rcsnycpizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1352698576664854854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rcs-nyc-pizza--pasta---the-woodlands",
      "poi_latitude": "30.125235000000004",
      "poi_longitude": "-95.4497807",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-298-4663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY2_EUzs0R4YRRgFJRjDAxRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_eb62eee1-4af3-4c3b-a989-e0aae8bb3e91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "CorkScrew BBQ",
      "poi_type": "Restaurants",
      "poi_address": "26608 Keith St, Spring, TX 77373, USA",
      "poi_short_description": "Trailer offering wood-smoked BBQ staples to diners at semicovered picnic tables (BYO).",
      "poi_long_description": "Trailer offering wood-smoked BBQ staples to diners at semicovered picnic tables (BYO).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e26-e178-72f9-93a9-c25f19656b4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e26-e178-72f9-93a9-c25f19656b4e",
        "storage_key": "property/6767906449167905/01a18e26-e178-72f9-93a9-c25f19656b4e.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "http://www.corkscrewbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8452398059256173365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corkscrew-bbq",
      "poi_latitude": "30.0806962",
      "poi_longitude": "-95.4199226",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-330-2178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRfY7ATs0R4YRNVMqjkDzTHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_297ee83c-ac6d-45c7-aadd-1972dbc9785a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "The Audrey",
      "poi_type": "Restaurants",
      "poi_address": "9595 Six Pines Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Upscale American restaurant and bar featuring elevated brunch and dinner classics, uniquely integrated with a luxury dine-in cinema.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-f18e-703d-99e4-629010ef2d69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-f18e-703d-99e4-629010ef2d69",
        "storage_key": "property/6767906449167905/01a18e28-f18e-703d-99e4-629010ef2d69.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.audreyrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10231199480324582608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-audrey",
      "poi_latitude": "30.1629227",
      "poi_longitude": "-95.4633666",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-924-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDRNy3gA3R4YR0GzoWriF_I0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_bf8c8fde-1c44-49c0-98cc-7ef023c36b94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Sushi Masa",
      "poi_type": "Restaurants",
      "poi_address": "355 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "Lively Japanese restaurant featuring all-you-can-eat sushi and hibachi.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-ef48-74df-bc31-005f340611e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-ef48-74df-bc31-005f340611e4",
        "storage_key": "property/6767906449167905/01a18e28-ef48-74df-bc31-005f340611e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sushimasaus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14815624427060571586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-masa",
      "poi_latitude": "30.1252953",
      "poi_longitude": "-95.4467006",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-298-5688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1V66CaY1R4YRwq2LfOurm80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_564a3cef-0e23-4208-be37-66c30a7708b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Mexican Mom Cocina Tradicional",
      "poi_type": "Restaurants",
      "poi_address": "1027 Sawdust Rd #375, Spring, TX 77380, USA",
      "poi_short_description": "Home-style Mexican eatery featuring a weekly rotating menu, savory empanadas, and enchiladas verdes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-f1ec-729c-8e43-51683b353b0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-f1ec-729c-8e43-51683b353b0e",
        "storage_key": "property/6767906449167905/01a18e28-f1ec-729c-8e43-51683b353b0e.webp",
        "width": 1280,
        "height": 1207
      },
      "poi_business_url": "https://www.mexmom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14667525059313099940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mexican-mom-cocina-tradicional",
      "poi_latitude": "30.1257448",
      "poi_longitude": "-95.4581031",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-614-1798",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJncLhpmQ1R4YRpGR_XlSEjcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_dba5c4b9-f262-4752-bf69-32a1b1af145d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "130 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17961-a69f-70e7-a0f6-bb3117af853f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-a69f-70e7-a0f6-bb3117af853f",
        "storage_key": "property/6767906449167905/01a17961-a69f-70e7-a0f6-bb3117af853f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/spring/sawdust-rd-and-45-h-e-b-564?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=7435462154694775165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "30.127641",
      "poi_longitude": "-95.44571",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-364-7744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edc7-775b-8f7b-c01bd478224f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edc7-775b-8f7b-c01bd478224f",
        "storage_key": "property/6767906449167905/01a1795e-edc7-775b-8f7b-c01bd478224f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwT-VrhMrXxQRfVFxV28RMGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_faa623d9-257e-4941-9bef-af9fdd6f8b65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1025 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "Well-stocked department store featuring a wide range of merchandise and convenient services like curbside pickup.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17961-a6ad-712c-b5b0-49b924beee12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-a6ad-712c-b5b0-49b924beee12",
        "storage_key": "property/6767906449167905/01a17961-a6ad-712c-b5b0-49b924beee12.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/602-spring-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3509517132777158394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.123537999999996",
      "poi_longitude": "-95.4576322",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-298-4306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd0-758d-b303-eba335571016.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd0-758d-b303-eba335571016",
        "storage_key": "property/6767906449167905/01a1795e-edd0-758d-b303-eba335571016.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH5KQxRc0R4YR-nZU8DxPtDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_5bb44fc5-d776-4397-8f90-06c0c698b8ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "River Pointe Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "512 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2616434545331536003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-pointe-pharmacy",
      "poi_latitude": "30.127438999999995",
      "poi_longitude": "-95.4499409",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 936-828-4337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-de6c-70d6-a442-77208ac2560a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6c-70d6-a442-77208ac2560a",
        "storage_key": "property/6767906449167905/01a17965-de6c-70d6-a442-77208ac2560a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz6NbBqA1R4YRgwCMRFtxTyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_6505a9b6-ee2f-447f-a45e-0d54a0726ccc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "485 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17961-bc22-71e9-9055-70e39c5227c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-bc22-71e9-9055-70e39c5227c4",
        "storage_key": "property/6767906449167905/01a17961-bc22-71e9-9055-70e39c5227c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-485+sawdust+rd-spring-tx-77380/id=1267",
      "poi_directions_map_url": "https://maps.google.com/?cid=18117802355637161522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.126169200000003",
      "poi_longitude": "-95.4489496",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-363-9583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzT1BKDs0R4YRMg59DkBdb_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_0f477c62-8688-4fab-96cf-82c536d7f150",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "710 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-f442-7338-9230-443324ea548e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-f442-7338-9230-443324ea548e",
        "storage_key": "property/6767906449167905/01a18e28-f442-7338-9230-443324ea548e.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/spring/710-sawdust-rd-41831?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2745735085059665337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "30.1269923",
      "poi_longitude": "-95.4547108",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 346-386-7346",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-de6a-741e-9bd1-0c5c21671e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6a-741e-9bd1-0c5c21671e81",
        "storage_key": "property/6767906449167905/01a17965-de6a-741e-9bd1-0c5c21671e81.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJG66TDlQ1R4YRue1OKIPPGiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_58976e85-89d7-4614-9996-ce35226ceaca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "SOL | Spirit of Light (formally Spirit Quest)",
      "poi_type": "Shopping & Retail",
      "poi_address": "303 Main St, Spring, TX 77373, USA",
      "poi_short_description": "Spiritual wellness shop offering a wide selection of crystals and metaphysical supplies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-f638-7781-94f6-77edcebdfc96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-f638-7781-94f6-77edcebdfc96",
        "storage_key": "property/6767906449167905/01a18e28-f638-7781-94f6-77edcebdfc96.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.arisingsol.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4573406414305835646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sol--spirit-of-light-formally-spirit-quest",
      "poi_latitude": "30.079093200000003",
      "poi_longitude": "-95.420029",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-288-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd0-758d-b303-eba335571016.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd0-758d-b303-eba335571016",
        "storage_key": "property/6767906449167905/01a1795e-edd0-758d-b303-eba335571016.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYzMR1RM1R4YRfjoxIucAeD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_6e918b7e-7df5-4ae4-8bdb-493770fc4ee7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "The Woodlands Farmers' Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "7 Switchbud Pl, The Woodlands, TX 77380, USA",
      "poi_short_description": "Non-profit Saturday market hosting local vendors of food, global fare & natural beauty products.",
      "poi_long_description": "Non-profit Saturday market hosting local vendors of food, global fare & natural beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-f461-770a-b7cb-650754f4947e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-f461-770a-b7cb-650754f4947e",
        "storage_key": "property/6767906449167905/01a18e28-f461-770a-b7cb-650754f4947e.webp",
        "width": 1280,
        "height": 375
      },
      "poi_business_url": "https://www.grogansmill.org/fmabout",
      "poi_directions_map_url": "https://maps.google.com/?cid=11276440583139887863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-farmers-market",
      "poi_latitude": "30.141274900000003",
      "poi_longitude": "-95.4706835",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 713-419-3388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd0-758d-b303-eba335571016.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd0-758d-b303-eba335571016",
        "storage_key": "property/6767906449167905/01a1795e-edd0-758d-b303-eba335571016.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLfuOoak2R4YR9wraGPf2fZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "custom_bdff2e58-cd96-43d8-a368-562b98ab3def",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Market Street",
      "poi_type": "Shopping & Retail",
      "poi_address": "9595 Six Pines Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Trendy, mixed-use town center housing luxury retailers, upscale restaurants, bars & a movie theater.",
      "poi_long_description": "Trendy, mixed-use town center housing luxury retailers, upscale restaurants, bars & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17962-bc6a-750e-b718-873e7480384c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-bc6a-750e-b718-873e7480384c",
        "storage_key": "property/6767906449167905/01a17962-bc6a-750e-b718-873e7480384c.webp",
        "width": 923,
        "height": 1280
      },
      "poi_business_url": "https://shopatmarketstreet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10104591045945142808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "30.1638371",
      "poi_longitude": "-95.4635036",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-419-4774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd0-758d-b303-eba335571016.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd0-758d-b303-eba335571016",
        "storage_key": "property/6767906449167905/01a1795e-edd0-758d-b303-eba335571016.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKVeL_8Y2R4YRGC4nFgW4Oow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_07db8286-fbe3-4c9b-bacd-213c40c346e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "The Woodlands Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1201 Lake Woodlands Dr #700, The Woodlands, TX 77380, USA",
      "poi_short_description": "Plaza for shoe, toy, familiar apparel & jewelry shops, plus a kid play area, carousel & food court.",
      "poi_long_description": "Plaza for shoe, toy, familiar apparel & jewelry shops, plus a kid play area, carousel & food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17962-821e-77bc-8707-5129acc82138.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-821e-77bc-8707-5129acc82138",
        "storage_key": "property/6767906449167905/01a17962-821e-77bc-8707-5129acc82138.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.thewoodlandsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8877476350304112571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-mall",
      "poi_latitude": "30.1643612",
      "poi_longitude": "-95.4539757",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-363-3363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd0-758d-b303-eba335571016.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd0-758d-b303-eba335571016",
        "storage_key": "property/6767906449167905/01a1795e-edd0-758d-b303-eba335571016.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1_a7Zuo2R4YRu8_OqbQhM3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9a04a3e8-0893-4137-8fc6-5308d4eaa178",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Lamar Elementary School",
      "poi_type": "Education",
      "poi_address": "1300 Many Pines Rd, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17962-34c6-75e5-9006-5d6866aa6f3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-34c6-75e5-9006-5d6866aa6f3c",
        "storage_key": "property/6767906449167905/01a17962-34c6-75e5-9006-5d6866aa6f3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lamar.conroeisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16526443570880448424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lamar-elementary-school",
      "poi_latitude": "30.154676",
      "poi_longitude": "-95.4552599",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-592-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edc7-775b-8f7b-c714a1b0c2c7",
        "storage_key": "property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ24iXbJY2R4YRqAfe6t24WeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_38031e9e-bdd2-4c98-bbf0-92ae410fdb48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Hailey Elementary School",
      "poi_type": "Education",
      "poi_address": "12051 Sawmill Rd, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://hailey.conroeisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9680519649348440411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hailey-elementary-school",
      "poi_latitude": "30.1335815",
      "poi_longitude": "-95.4653881",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 832-663-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edc7-775b-8f7b-c714a1b0c2c7",
        "storage_key": "property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWSBMlBo0R4YRW1Ga3FQdWIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_722e53bf-d025-4d9c-b678-9c4bd5b4a30e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "David Elementary School",
      "poi_type": "Education",
      "poi_address": "5301 Shadowbend Pl, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-fa95-752e-a719-24537056f586.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-fa95-752e-a719-24537056f586",
        "storage_key": "property/6767906449167905/01a18e28-fa95-752e-a719-24537056f586.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://david.conroeisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=696526986399660249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "david-elementary-school",
      "poi_latitude": "30.1786346",
      "poi_longitude": "-95.5032044",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-298-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edc7-775b-8f7b-c714a1b0c2c7",
        "storage_key": "property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo_orkB4xR4YR2TjTkJqPqgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_819e05d7-0b16-4244-af9f-9327d3a3266e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Knox Junior High School",
      "poi_type": "Education",
      "poi_address": "12104 Sawmill Rd, Spring, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://knox.conroeisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2341242613658048160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "knox-junior-high-school",
      "poi_latitude": "30.131359999999997",
      "poi_longitude": "-95.4644948",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 832-592-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edc7-775b-8f7b-c714a1b0c2c7",
        "storage_key": "property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf0KB0xw0R4YRoFYYsMDDfSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_027c8402-228c-41dd-87af-b3738ee96dfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "The Woodlands College Park High School",
      "poi_type": "Education",
      "poi_address": "3701 College Park Dr, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17962-5729-746e-88e5-9d446c631aee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-5729-746e-88e5-9d446c631aee",
        "storage_key": "property/6767906449167905/01a17962-5729-746e-88e5-9d446c631aee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://twcp.conroeisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10132254085328821925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-college-park-high-school",
      "poi_latitude": "30.2045668",
      "poi_longitude": "-95.4717587",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 936-709-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edc7-775b-8f7b-c714a1b0c2c7",
        "storage_key": "property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzZH_VDU3R4YRpV4GWmj_nIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a57f6e52-11fd-4c65-8e73-a23ba18caacd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Childtime of Spring",
      "poi_type": "Education",
      "poi_address": "417 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-f80f-723f-9996-c4adfb7cd89c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-f80f-723f-9996-c4adfb7cd89c",
        "storage_key": "property/6767906449167905/01a18e28-f80f-723f-9996-c4adfb7cd89c.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.childtime.com/your-local-school/spring-tx-1276/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=1276",
      "poi_directions_map_url": "https://maps.google.com/?cid=2669063450084438742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childtime-of-spring",
      "poi_latitude": "30.1248672",
      "poi_longitude": "-95.4488909",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 877-220-0584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edc7-775b-8f7b-c714a1b0c2c7",
        "storage_key": "property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSTv1LTs0R4YR1vJCCRFrCiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_f855339b-54b3-491d-b79a-54066e72fe38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "The Woodlands Montessori",
      "poi_type": "Education",
      "poi_address": "1201 Many Pines Rd, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17962-61b9-73b8-991a-3324dfed4049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-61b9-73b8-991a-3324dfed4049",
        "storage_key": "property/6767906449167905/01a17962-61b9-73b8-991a-3324dfed4049.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.montessori.com/montessori-schools/the-woodlands-tx-7351/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7351",
      "poi_directions_map_url": "https://maps.google.com/?cid=5098891607063183139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-montessori",
      "poi_latitude": "30.1523228",
      "poi_longitude": "-95.4544023",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 855-467-7115",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edc7-775b-8f7b-c714a1b0c2c7",
        "storage_key": "property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1tHqpc2R4YRI784y-bmwkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_049d32db-c394-4bfc-9a0a-5072cbf33a46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "YMCA at Shadowbend",
      "poi_type": "Health and Wellness",
      "poi_address": "6145 Shadowbend Pl, The Woodlands, TX 77381, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-fbb2-75cb-af0a-bd5c7afcbb78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-fbb2-75cb-af0a-bd5c7afcbb78",
        "storage_key": "property/6767906449167905/01a18e28-fbb2-75cb-af0a-bd5c7afcbb78.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcahouston.org/locations/woodlands-family-ymca-shadowbend",
      "poi_directions_map_url": "https://maps.google.com/?cid=9004810389884081119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ymca-at-shadowbend",
      "poi_latitude": "30.18653",
      "poi_longitude": "-95.492183",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-367-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edc7-775b-8f7b-c714a1b0c2c7",
        "storage_key": "property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFawTLtkwR4YR35PJDleD93w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_6fda4c3c-7155-426f-a6c8-78b43647d825",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "University Center at LSC-Montgomery",
      "poi_type": "Education",
      "poi_address": "3232 College Park Dr, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-b3e1-73fe-a6f6-8b1623134a33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17965-b3e1-73fe-a6f6-8b1623134a33",
        "storage_key": "property/6767906449167905/01a17965-b3e1-73fe-a6f6-8b1623134a33.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lonestar.edu/university-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11019746505089322714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-center-at-lsc-montgomery",
      "poi_latitude": "30.2089444",
      "poi_longitude": "-95.4679105",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-618-7140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edc7-775b-8f7b-c714a1b0c2c7",
        "storage_key": "property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI3Ttekg3R4YR2o6zrg8B7pg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "custom_c3552272-e81f-46cf-88b1-6bc70bd7368b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "SHSU - The Woodlands Center",
      "poi_type": "Education",
      "poi_address": "3380 College Park Dr, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-f939-718e-baec-1cb945ab8c3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-f939-718e-baec-1cb945ab8c3c",
        "storage_key": "property/6767906449167905/01a18e28-f939-718e-baec-1cb945ab8c3c.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "http://www.shsu.edu/academics/woodlands-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1907815939368180908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shsu---the-woodlands-center",
      "poi_latitude": "30.2091764",
      "poi_longitude": "-95.4706137",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 936-202-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edc7-775b-8f7b-c714a1b0c2c7",
        "storage_key": "property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI7NKr0k3R4YRrFzeIn3seRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b25b4ba9-371a-4832-b14e-c0d9858c7f73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "The Cynthia Woods Mitchell Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "2005 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Unique outdoor performance space surrounded by trees features live music, theater & dance shows.",
      "poi_long_description": "Unique outdoor performance space surrounded by trees features live music, theater & dance shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17962-d376-7022-bd69-52ab6fa581f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-d376-7022-bd69-52ab6fa581f4",
        "storage_key": "property/6767906449167905/01a17962-d376-7022-bd69-52ab6fa581f4.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.woodlandscenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9903810310770188732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cynthia-woods-mitchell-pavilion",
      "poi_latitude": "30.161426499999997",
      "poi_longitude": "-95.4640655",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-364-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-de6b-72b4-8c33-d9dce04708f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6b-72b4-8c33-d9dce04708f9",
        "storage_key": "property/6767906449167905/01a17965-de6b-72b4-8c33-d9dce04708f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWcAcMc2R4YRvOFOSAFncYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_daf2db2f-54d0-41ad-8a3e-b24e2c94ed42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Waterway Square",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "31 Waterway Square Pl, The Woodlands, TX 77380, USA",
      "poi_short_description": "Scenic waterfront park offering pedestrian trails and family-friendly dining and shopping.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17962-d429-7255-a0ac-2ca890a30db4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-d429-7255-a0ac-2ca890a30db4",
        "storage_key": "property/6767906449167905/01a17962-d429-7255-a0ac-2ca890a30db4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17628338246645918111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waterway-square",
      "poi_latitude": "30.1601821",
      "poi_longitude": "-95.4584432",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-0cb3-7039-9a0a-42a3487c6727",
        "storage_key": "property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfaqqL82R4YRnynDgzxwpPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4c6a8ef1-eb0b-4173-bb2a-b97cc87c3799",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Riva Row Boat House",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2101 Riva Row, The Woodlands, TX 77380, USA",
      "poi_short_description": "Lakeside watercraft rental offering kayaks, paddleboards, and swan pedal boats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17963-ede2-70ab-86ca-3e9830405707.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17963-ede2-70ab-86ca-3e9830405707",
        "storage_key": "property/6767906449167905/01a17963-ede2-70ab-86ca-3e9830405707.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://rivarowboathouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17084086843900672828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riva-row-boat-house",
      "poi_latitude": "30.16001769999999",
      "poi_longitude": "-95.4665433",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-210-2066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-0cb3-7039-9a0a-42a3487c6727",
        "storage_key": "property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWo7ELg2R4YRPLufGnjeFu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_8a0ee3e1-77a8-478d-a9b0-5218d713bbee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Texas TreeVentures",
      "poi_type": "Entertainment",
      "poi_address": "6464 Creekside Forest Dr, The Woodlands, TX 77389, USA",
      "poi_short_description": "Aerial adventure course featuring multi-level climbing and obstacle challenges.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-fa6c-779e-b35f-16e267811dde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-fa6c-779e-b35f-16e267811dde",
        "storage_key": "property/6767906449167905/01a18e28-fa6c-779e-b35f-16e267811dde.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://texastreeventures.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4466731967841460003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-treeventures",
      "poi_latitude": "30.149643499999996",
      "poi_longitude": "-95.5177122",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-210-2048",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-ef69-75ba-9816-2e332447914e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-ef69-75ba-9816-2e332447914e",
        "storage_key": "property/6767906449167905/01a1795e-ef69-75ba-9816-2e332447914e.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJM2K5_BwxR4YRI18SGg8F_T0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "adventure_sports_center"
    },
    {
      "id": "custom_705a6253-e634-4bce-adb7-8a101eeffe96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "The Woodlands Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "4775 W Panther Creek Dr #280, The Woodlands, TX 77381, USA",
      "poi_short_description": "Interactive exhibits & imaginative play are the focus of this museum designed for young children.",
      "poi_long_description": "Interactive exhibits & imaginative play are the focus of this museum designed for young children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17962-62df-731d-82f1-7bc130ba8313.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-62df-731d-82f1-7bc130ba8313",
        "storage_key": "property/6767906449167905/01a17962-62df-731d-82f1-7bc130ba8313.webp",
        "width": 400,
        "height": 400
      },
      "poi_business_url": "http://woodlandschildrensmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1661874245600597207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-childrens-museum",
      "poi_latitude": "30.167706",
      "poi_longitude": "-95.502756",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-465-0955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-ec95-755d-bd48-16aa4940d422.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-ec95-755d-bd48-16aa4940d422",
        "storage_key": "property/6767906449167905/01a1795e-ec95-755d-bd48-16aa4940d422.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJqcYNveo2R4YR19RkRtIpEBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e87c9500-e800-48a6-abc8-a3da24bde8cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "AMC Spring 10",
      "poi_type": "Entertainment",
      "poi_address": "20115 Holzwarth Rd, Spring, TX 77388, USA",
      "poi_short_description": "Movie theater featuring comfortable reclining seats and concession offerings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17962-e310-7518-8671-fb4d9d6e5b40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17962-e310-7518-8671-fb4d9d6e5b40",
        "storage_key": "property/6767906449167905/01a17962-e310-7518-8671-fb4d9d6e5b40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/houston/amc-spring-10?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18408731182930154681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-spring-10",
      "poi_latitude": "30.057263100000004",
      "poi_longitude": "-95.4384621",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-288-5061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-de6a-741e-9bd1-0754ad1f55c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6a-741e-9bd1-0754ad1f55c9",
        "storage_key": "property/6767906449167905/01a17965-de6a-741e-9bd1-0754ad1f55c9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJV53Gmtc0R4YRuVQ1LHrzeP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_c89e7dfb-838b-4679-b802-81b2c41cfc2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Sawyer Park Icehouse",
      "poi_type": "Restaurants",
      "poi_address": "314 Pruitt Rd, Spring, TX 77380, USA",
      "poi_short_description": "Expansive sports-centric venue with a terrace offering drinks, live music & Southern-style pub grub.",
      "poi_long_description": "Expansive sports-centric venue with a terrace offering drinks, live music & Southern-style pub grub.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e26-e870-704a-bebe-7e36b4a0b453.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e26-e870-704a-bebe-7e36b4a0b453",
        "storage_key": "property/6767906449167905/01a18e26-e870-704a-bebe-7e36b4a0b453.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sawyerpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10843958124895542462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sawyer-park-icehouse",
      "poi_latitude": "30.1199543",
      "poi_longitude": "-95.4456812",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-362-5907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edd1-726b-800a-bcb1c8f5bb41",
        "storage_key": "property/6767906449167905/01a1795e-edd1-726b-800a-bcb1c8f5bb41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT2aIyGE1R4YRvhyc-XV6fZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_36d1c8fd-8335-424f-bf10-3c7d10aec3ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Old Town Spring",
      "poi_type": "Entertainment",
      "poi_address": "606 Spring Cypress Rd, Spring, TX 77373, USA",
      "poi_short_description": "Historic turn-of-the-century settlement features a variety of Victorian-style restaurants & shops.",
      "poi_long_description": "Historic turn-of-the-century settlement features a variety of Victorian-style restaurants & shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17961-dedc-7350-bc9e-f1122c231b45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-dedc-7350-bc9e-f1122c231b45",
        "storage_key": "property/6767906449167905/01a17961-dedc-7350-bc9e-f1122c231b45.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oldtownspringshopping.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=690816813901608507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town-spring",
      "poi_latitude": "30.0794322",
      "poi_longitude": "-95.4231525",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-288-8177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-ef69-75ba-9816-2e332447914e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-ef69-75ba-9816-2e332447914e",
        "storage_key": "property/6767906449167905/01a1795e-ef69-75ba-9816-2e332447914e.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJiR1GdhE1R4YRO_Z4bTtGlgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_information_center"
    },
    {
      "id": "custom_307a3a3a-06db-4e3f-b05f-8d095760738b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Memorial Hermann The Woodlands Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9250 Pinecroft Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795c-0ef3-72ef-a53f-e204feb7f157.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1795c-0ef3-72ef-a53f-e204feb7f157",
        "storage_key": "property/6767906449167905/01a1795c-0ef3-72ef-a53f-e204feb7f157.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://memorialhermann.org/locations/woodlands?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980774261720927425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-the-woodlands-medical-center",
      "poi_latitude": "30.174316299999997",
      "poi_longitude": "-95.4542271",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 713-897-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-ec96-732b-a010-ba1fbf88c03a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-ec96-732b-a010-ba1fbf88c03a",
        "storage_key": "property/6767906449167905/01a1795e-ec96-732b-a010-ba1fbf88c03a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJgefV08Q2R4YRwcxIQM1DH0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_cf869046-6383-42d5-8c50-9408e428a72a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Memorial Hermann-GoHealth Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "10868 Kuykendahl Rd, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-fc94-75d3-9c7b-43b58f08a770.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-fc94-75d3-9c7b-43b58f08a770",
        "storage_key": "property/6767906449167905/01a18e28-fc94-75d3-9c7b-43b58f08a770.webp",
        "width": 1280,
        "height": 1113
      },
      "poi_business_url": "https://www.gohealthuc.com/memorialhermann/locations/the-woodlands?utm_source=gmb&utm_medium=organic&utm_content=memorialhermann-the-woodlands",
      "poi_directions_map_url": "https://maps.google.com/?cid=2345917095604724447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-gohealth-urgent-care",
      "poi_latitude": "30.176287699999996",
      "poi_longitude": "-95.5362765",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 346-478-0831",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2e6H70xR4YR3yIJVCtfjiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_8a2bfad2-b33d-436c-ac9f-cb20f6277a06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Spring",
      "poi_type": "Health and Wellness",
      "poi_address": "2540 Farm to Market 2920, Spring, TX 77388, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-fcdd-76e5-a3b9-917ec8594385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-fcdd-76e5-a3b9-917ec8594385",
        "storage_key": "property/6767906449167905/01a18e28-fcdd-76e5-a3b9-917ec8594385.webp",
        "width": 1080,
        "height": 1118
      },
      "poi_business_url": "https://www.carenow.com/locations/houston/spring?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18196748585641568613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---spring",
      "poi_latitude": "30.071121700000003",
      "poi_longitude": "-95.4567314",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 832-271-5168",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7WGdzUg1R4YRZelBmm3Wh_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_e1fb1971-8684-4fb9-b747-b2baf14402db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "25110 Grogans Mill Rd, Spring, TX 77380, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17961-ca36-732a-9d48-a593d30e8400.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17961-ca36-732a-9d48-a593d30e8400",
        "storage_key": "property/6767906449167905/01a17961-ca36-732a-9d48-a593d30e8400.webp",
        "width": 1280,
        "height": 558
      },
      "poi_business_url": "https://www.cvs.com/store-locator/spring-tx-pharmacies/25110-grogans-mill-rd-spring-tx-77380/storeid=7108?WT.mc_id=LS_GOOGLE_FS_7108",
      "poi_directions_map_url": "https://maps.google.com/?cid=14448486645376123796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "30.128101",
      "poi_longitude": "-95.4549708",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-363-2290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFblewiI0R4YRlIOedw1Wg8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_fd8a3cbe-c47f-4e30-87ff-6bb9e4781ba3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1025 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17963-3580-75bf-9076-678b05b5d05c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17963-3580-75bf-9076-678b05b5d05c",
        "storage_key": "property/6767906449167905/01a17963-3580-75bf-9076-678b05b5d05c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/602-spring-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5964725892633641344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "30.123537999999996",
      "poi_longitude": "-95.4576322",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-298-2547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-de6c-70d6-a442-77208ac2560a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6c-70d6-a442-77208ac2560a",
        "storage_key": "property/6767906449167905/01a17965-de6c-70d6-a442-77208ac2560a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfy-vMxY0R4YRgMEAzZj2xlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_52cac3d3-43c9-4a00-9a77-95c659a27093",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "485 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-fd45-7269-b5ee-b0c8a6c29a05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-fd45-7269-b5ee-b0c8a6c29a05",
        "storage_key": "property/6767906449167905/01a18e28-fd45-7269-b5ee-b0c8a6c29a05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-485+sawdust+rd-spring-tx-77380/id=1267",
      "poi_directions_map_url": "https://maps.google.com/?cid=12600601969928744914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "30.126359200000003",
      "poi_longitude": "-95.4491026",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-363-9583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-de6c-70d6-a442-77208ac2560a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-de6c-70d6-a442-77208ac2560a",
        "storage_key": "property/6767906449167905/01a17965-de6c-70d6-a442-77208ac2560a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyV79Jzs0R4YR0q-wFbtU3q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_718a6acd-4a2b-485d-a6e6-dedcd85abf9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "20127 I-45, Spring, TX 77388, USA",
      "poi_short_description": "Full-service gym featuring extensive workout equipment, a pool, and a sauna.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795c-1d77-77f2-9561-1399e0ceb1bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1795c-1d77-77f2-9561-1399e0ceb1bb",
        "storage_key": "property/6767906449167905/01a1795c-1d77-77f2-9561-1399e0ceb1bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=351&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10439115990156757036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "30.055396199999997",
      "poi_longitude": "-95.4343795",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-350-4298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX55hTSg1R4YRLMhkKq8w35A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7e0b4adf-4bba-4874-9abe-1f0eda3c575e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "21356 Kuykendahl Rd, Spring, TX 77379, USA",
      "poi_short_description": "Well-maintained gym offering a wide variety of cardio and strength equipment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795b-99c1-7209-a08b-7d9252dbad71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1795b-99c1-7209-a08b-7d9252dbad71",
        "storage_key": "property/6767906449167905/01a1795b-99c1-7209-a08b-7d9252dbad71.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/spring-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4904316356339894784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "30.078920000000004",
      "poi_longitude": "-95.51673",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 832-447-7675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxZ5cQszR4YRAArH7b2hD0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d83667af-2a42-4f79-8cb9-a778e293d557",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Alpine Yoga & Wellness | The Woodlands",
      "poi_type": "Health and Wellness",
      "poi_address": "255 Ed English Dr Ste E, The Woodlands, TX 77385, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e29-0019-7538-aa6f-c1a54e557cfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e29-0019-7538-aa6f-c1a54e557cfd",
        "storage_key": "property/6767906449167905/01a18e29-0019-7538-aa6f-c1a54e557cfd.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://alpineyogalec.com/?utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12266733201405114841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alpine-yoga--wellness--the-woodlands",
      "poi_latitude": "30.190243400000004",
      "poi_longitude": "-95.4506308",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 936-681-7099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-edc7-775b-8f7b-c714a1b0c2c7",
        "storage_key": "property/6767906449167905/01a1795e-edc7-775b-8f7b-c714a1b0c2c7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ026YCM3R4YR2fk90NowPKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_a28eede5-d046-4604-92de-ab9b3bce8b9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "The Woodlands Institute for Health & Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "26110 Oak Ridge Dr, Spring, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e28-fff2-74fa-bfc6-da603946f498.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e28-fff2-74fa-bfc6-da603946f498",
        "storage_key": "property/6767906449167905/01a18e28-fff2-74fa-bfc6-da603946f498.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://woodlandswellnessmd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10062759528942147849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-institute-for-health--wellness",
      "poi_latitude": "30.141394",
      "poi_longitude": "-95.447875",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 281-298-6742",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu0AHG502R4YRCRnGDnoapos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_3c1be412-cf68-4606-aea9-d374dbeee164",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Town Green Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2099 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Immense open lawns highlight this public green space which features an amphitheater & a labyrinth.",
      "poi_long_description": "Immense open lawns highlight this public green space which features an amphitheater & a labyrinth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795c-81d3-708a-9991-eb937b6818c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1795c-81d3-708a-9991-eb937b6818c6",
        "storage_key": "property/6767906449167905/01a1795c-81d3-708a-9991-eb937b6818c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://woodlandsevents.com/parks/town-center/town-green-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8406987068125119440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-green-park",
      "poi_latitude": "30.1617206",
      "poi_longitude": "-95.466142",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-210-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-0cb3-7039-9a0a-42a3487c6727",
        "storage_key": "property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdTr47Mc2R4YR0IPmQjKeq3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_395c73d2-21a7-4f2f-9385-cb2a92d83387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Northshore Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2505 Lake Woodlands Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Waterfront space with playgrounds, picnic spots & a field, plus outdoor concerts & other events.",
      "poi_long_description": "Waterfront space with playgrounds, picnic spots & a field, plus outdoor concerts & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795b-fbda-711f-b589-dbbbc7bc2590.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1795b-fbda-711f-b589-dbbbc7bc2590",
        "storage_key": "property/6767906449167905/01a1795b-fbda-711f-b589-dbbbc7bc2590.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thewoodlandsparks.com/Parks/Community-Parks/Parks-Directory/Panther-Creek-Parks/Northshore-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18307336104189955607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northshore-park",
      "poi_latitude": "30.1687385",
      "poi_longitude": "-95.4765267",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-210-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-0cb3-7039-9a0a-42a3487c6727",
        "storage_key": "property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Rjz4Mw2R4YRFw7tuTC5EP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_093b0269-32a4-40d7-9845-7bb0ba3c9d0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Rob Fleming Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6055 Creekside Forest Dr, Spring, TX 77389, USA",
      "poi_short_description": "Spacious, grassy area with a pavilion for picnicking, a pond for fishing & a butterfly garden.",
      "poi_long_description": "Spacious, grassy area with a pavilion for picnicking, a pond for fishing & a butterfly garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795b-a1a1-748b-96fd-cb723465cef5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1795b-a1a1-748b-96fd-cb723465cef5",
        "storage_key": "property/6767906449167905/01a1795b-a1a1-748b-96fd-cb723465cef5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.thewoodlandstownship-tx.gov/Facility/Details/Rob-Fleming-Park-74",
      "poi_directions_map_url": "https://maps.google.com/?cid=18276279185301868626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rob-fleming-park",
      "poi_latitude": "30.1445205",
      "poi_longitude": "-95.51368",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-210-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-0cb3-7039-9a0a-42a3487c6727",
        "storage_key": "property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ08beoJAxR4YRUpDITxZjov0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2d3ca2fd-28ae-4b36-addc-6fc10ade4ef2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "George Mitchell Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5171 Flintridge Dr, The Woodlands, TX 77381, USA",
      "poi_short_description": "This large, forested nature preserve offers a hiking trail loop, bike trails & a lake.",
      "poi_long_description": "This large, forested nature preserve offers a hiking trail loop, bike trails & a lake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17964-6006-73de-aeb5-b51dcc122781.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17964-6006-73de-aeb5-b51dcc122781",
        "storage_key": "property/6767906449167905/01a17964-6006-73de-aeb5-b51dcc122781.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thewoodlandstx.com/parks/george-mitchell-nature-preserve.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=11777471143174761687&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-mitchell-nature-preserve",
      "poi_latitude": "30.1629373",
      "poi_longitude": "-95.5177717",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-210-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-0cb3-7039-9a0a-42a3487c6727",
        "storage_key": "property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy0LrRgoxR4YR12xY4Zr7caM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_c91ad9f1-db34-41ee-b260-97f55b7c35ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Spring Creek Greenway Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 Riley Fuzzel Rd, Spring, TX 77386, USA",
      "poi_short_description": "Facility for natural history programs & wildlife exhibits, with trails, a fishing pond & playground.",
      "poi_long_description": "Facility for natural history programs & wildlife exhibits, with trails, a fishing pond & playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-63c6-75ad-807d-96018fce7e2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17965-63c6-75ad-807d-96018fce7e2b",
        "storage_key": "property/6767906449167905/01a17965-63c6-75ad-807d-96018fce7e2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://scgnaturecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5641412788558996010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-creek-greenway-nature-center",
      "poi_latitude": "30.095915",
      "poi_longitude": "-95.400957",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-364-4225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-0cb3-7039-9a0a-42a3487c6727",
        "storage_key": "property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm38dXoI1R4YRKqJnrQpTSk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_87bd7ed9-6d6a-4be1-a7ea-48ed806a784c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Pundt Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4129 Spring Creek Dr, Spring, TX 77373, USA",
      "poi_short_description": "Large recreation area offering multiple fishing lakes, unpaved trails, picnic areas & a dog park.",
      "poi_long_description": "Large recreation area offering multiple fishing lakes, unpaved trails, picnic areas & a dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17964-3671-7224-85ba-427ade43ab0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17964-3671-7224-85ba-427ade43ab0b",
        "storage_key": "property/6767906449167905/01a17964-3671-7224-85ba-427ade43ab0b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.pct3.com/Explore/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=4049805824425800360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pundt-park",
      "poi_latitude": "30.0820654",
      "poi_longitude": "-95.3784021",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-274-0930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-0cb3-7039-9a0a-42a3487c6727",
        "storage_key": "property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXfL_z5NKR4YRqDI1xvDMMzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c7e6a5b1-0871-431f-81c0-264b34093c27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Mercer Botanic Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "22306 Aldine Westfield Rd, Humble, TX 77338, USA",
      "poi_short_description": "300 acres of native & cultivated plants along with butterflies, birds & special seasonal events.",
      "poi_long_description": "300 acres of native & cultivated plants along with butterflies, birds & special seasonal events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17964-7fe0-77cc-9f07-4ff441dce7f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17964-7fe0-77cc-9f07-4ff441dce7f9",
        "storage_key": "property/6767906449167905/01a17964-7fe0-77cc-9f07-4ff441dce7f9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.pct3.com/MBG",
      "poi_directions_map_url": "https://maps.google.com/?cid=2942094030102634232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercer-botanic-gardens",
      "poi_latitude": "30.03799549999999",
      "poi_longitude": "-95.381209",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-274-4160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-dc4f-717e-b78f-a534487ec704.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-dc4f-717e-b78f-a534487ec704",
        "storage_key": "property/6767906449167905/01a17965-dc4f-717e-b78f-a534487ec704.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbdxOdU-1QIYR-J4QuO5q1Cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_b8d3a107-1a00-48ba-b077-bc74bc102dc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Lakes Edge Boat House",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1970 Hughes Landing Blvd, The Woodlands, TX 77380, USA",
      "poi_short_description": "Boat rental outfit offering canoes and kayaks for paddling on Lake Woodlands.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e29-0480-7188-90c3-44123a4f0c1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e29-0480-7188-90c3-44123a4f0c1f",
        "storage_key": "property/6767906449167905/01a18e29-0480-7188-90c3-44123a4f0c1f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lakesedgeboathouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16494928151149288956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakes-edge-boat-house",
      "poi_latitude": "30.1704917",
      "poi_longitude": "-95.4731831",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-210-2065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795f-0cb3-7039-9a0a-42a3487c6727",
        "storage_key": "property/6767906449167905/01a1795f-0cb3-7039-9a0a-42a3487c6727.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01xM3c02R4YR_B3YdMLB6eQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_819684b0-0634-4bf1-94c3-fc70def7eb46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Research Forest Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "3900 Marsico Pl, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-265c-77ac-bfe5-d99eaabaea07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17965-265c-77ac-bfe5-d99eaabaea07",
        "storage_key": "property/6767906449167905/01a17965-265c-77ac-bfe5-d99eaabaea07.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://woodlandstransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15778184797064041952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "research-forest-park--ride",
      "poi_latitude": "30.1927936",
      "poi_longitude": "-95.4748177",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 936-273-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKSOpKuM3R4YR4JV4_Xlf99o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_e1e1c050-30e0-4e69-a126-8dbd200595ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Sawdust Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "701 Westridge Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17964-8f27-73be-9558-721dd54f9dbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17964-8f27-73be-9558-721dd54f9dbf",
        "storage_key": "property/6767906449167905/01a17964-8f27-73be-9558-721dd54f9dbf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thewoodlandstownship-tx.gov/Departments/Transportation",
      "poi_directions_map_url": "https://maps.google.com/?cid=18193597785316610762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sawdust-park--ride",
      "poi_latitude": "30.120356599999997",
      "poi_longitude": "-95.4537951",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-363-0882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpx6oJzw0R4YRylIhvMqkfPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_32d8f783-38ad-4ea1-8982-c108865fd5c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Sterling Ridge Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "8001 McBeth Way, The Woodlands, TX 77382, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17964-c335-7398-a240-275d707e09bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17964-c335-7398-a240-275d707e09bb",
        "storage_key": "property/6767906449167905/01a17964-c335-7398-a240-275d707e09bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thewoodlandstownship-tx.gov/Departments/Transportation",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548114769123178756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sterling-ridge-park--ride",
      "poi_latitude": "30.1812573",
      "poi_longitude": "-95.5592182",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-363-1325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqj4wR4YRBHmDzOG4XCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_7ab5ddf6-fcbc-4e72-9f95-11df72d93afc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "The Woodlands Township Trolley Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 Westridge Dr, Spring, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.thewoodlandstownship-tx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6273890671774275294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-township-trolley-center",
      "poi_latitude": "30.1210626",
      "poi_longitude": "-95.4534343",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8RuuN-E1R4YR3ha-UlNWEVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_b681c1fa-f6ca-4528-beeb-3c96cdabb047",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "The Woodlands Township",
      "poi_type": "Transportation & Transit",
      "poi_address": "2801 Technology Forest Blvd, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-9fe3-7247-bc52-37f6e669500b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17965-9fe3-7247-bc52-37f6e669500b",
        "storage_key": "property/6767906449167905/01a17965-9fe3-7247-bc52-37f6e669500b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thewoodlandstownship-tx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15961375474051580714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-township",
      "poi_latitude": "30.176916399999996",
      "poi_longitude": "-95.4796936",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-210-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-dc50-74fe-971a-8f3b4e299d27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-dc50-74fe-971a-8f3b4e299d27",
        "storage_key": "property/6767906449167905/01a17965-dc50-74fe-971a-8f3b4e299d27.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrZp9fJU2R4YRKgN6OW0ygt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fb65b069-61bb-4edd-a5b9-4c1154333fd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "George Bush Intercontinental Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 N Terminal Rd, Houston, TX 77032, USA",
      "poi_short_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_long_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-873c-711d-b0ed-8b47dc95043e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17965-873c-711d-b0ed-8b47dc95043e",
        "storage_key": "property/6767906449167905/01a17965-873c-711d-b0ed-8b47dc95043e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fly2houston.com/iah/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11296915713098302001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-intercontinental-airport",
      "poi_latitude": "29.9931058",
      "poi_longitude": "-95.3416255",
      "poi_miles_from_property": "22.5 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 281-230-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-dc16-7130-a3fa-c86fa3cee700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17965-dc16-7130-a3fa-c86fa3cee700",
        "storage_key": "property/6767906449167905/01a17965-dc16-7130-a3fa-c86fa3cee700.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VD2SO0QIYRMcLAyPy0xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_7479b3d3-ac93-4dac-a6c8-18113dda89d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Houston Methodist The Woodlands Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "17201 I-45, Conroe, TX 77385, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-5ddb-716b-82dd-ce05233aed22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17965-5ddb-716b-82dd-ce05233aed22",
        "storage_key": "property/6767906449167905/01a17965-5ddb-716b-82dd-ce05233aed22.webp",
        "width": 1140,
        "height": 560
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/the-woodlands/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=12078372465785096765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-the-woodlands-hospital",
      "poi_latitude": "30.205899799999997",
      "poi_longitude": "-95.4524193",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 936-270-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-ec96-732b-a010-ba1fbf88c03a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-ec96-732b-a010-ba1fbf88c03a",
        "storage_key": "property/6767906449167905/01a1795e-ec96-732b-a010-ba1fbf88c03a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHVog23DAQIYRPcr6f8P_nqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_59b30715-a7e5-42ea-97a6-c5510ac3df03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Texas Children's Hospital The Woodlands Inpatient and Emergency",
      "poi_type": "Health and Wellness",
      "poi_address": "17600 I-45, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-7157-752a-b23d-942b9ed8e2c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17965-7157-752a-b23d-942b9ed8e2c1",
        "storage_key": "property/6767906449167905/01a17965-7157-752a-b23d-942b9ed8e2c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texaschildrens.org/locations/texas-childrens-hospital/the-woodlands",
      "poi_directions_map_url": "https://maps.google.com/?cid=9082928018215836934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-childrens-hospital-the-woodlands-inpatient-and-emergency",
      "poi_latitude": "30.200914399999995",
      "poi_longitude": "-95.4575802",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 936-267-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-ec96-732b-a010-ba1fbf88c03a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-ec96-732b-a010-ba1fbf88c03a",
        "storage_key": "property/6767906449167905/01a1795e-ec96-732b-a010-ba1fbf88c03a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsxSKWRU3R4YRBp0yvugKDX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_90d7c168-1308-4518-852f-3dbdddee2af9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Chevron Phillips Chemical Company LP",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9500 Lakeside Blvd, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-808a-7342-a166-d503715523cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17965-808a-7342-a166-d503715523cf",
        "storage_key": "property/6767906449167905/01a17965-808a-7342-a166-d503715523cf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cpchem.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8985774748554964679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevron-phillips-chemical-company-lp",
      "poi_latitude": "30.1721239",
      "poi_longitude": "-95.4746216",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 832-813-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi2HINLk2R4YRxy5Lb4bis3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_7985c292-ac20-4e8a-93ad-3cd870d50ab5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Huntsman Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10003 Woodloch Forest Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e29-04ad-7076-9f50-69c963b4a447.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e29-04ad-7076-9f50-69c963b4a447",
        "storage_key": "property/6767906449167905/01a18e29-04ad-7076-9f50-69c963b4a447.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "http://www.huntsman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9653596631800691034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huntsman-corporation",
      "poi_latitude": "30.1596901",
      "poi_longitude": "-95.4561671",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-719-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Zn4YJU2R4YRWjljW_12-IU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_eceae976-e193-44f4-8ac1-5265c08b768d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Oxy - The Woodlands",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a17965-a168-737a-bc57-dd8d2e19589f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17965-a168-737a-bc57-dd8d2e19589f",
        "storage_key": "property/6767906449167905/01a17965-a168-737a-bc57-dd8d2e19589f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.oxy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4159763738033508273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxy---the-woodlands",
      "poi_latitude": "30.1607374",
      "poi_longitude": "-95.4529159",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-636-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyUfRjc21QIYRsc8JkxRzujk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dd56471c-89ad-4fc9-a80c-e7d0336d1a7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Baker Hughes",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9110 Grogans Mill Rd, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.bakerhughes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3977024958519619476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baker-hughes",
      "poi_latitude": "30.1731608",
      "poi_longitude": "-95.464037",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-363-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPQLIF9s2R4YRlK9s6yA7MTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6638cc38-0423-43cd-8013-c5e44d20543f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "McKesson",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9950 Woodloch Forest Dr Fl 17, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e29-0720-70cb-adb7-f7955979ba17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e29-0720-70cb-adb7-f7955979ba17",
        "storage_key": "property/6767906449167905/01a18e29-0720-70cb-adb7-f7955979ba17.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mckesson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12169981805514588670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckesson",
      "poi_latitude": "30.160317",
      "poi_longitude": "-95.4552148",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 866-951-2774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1795e-efb3-736e-8977-24f92d420c51",
        "storage_key": "property/6767906449167905/01a1795e-efb3-736e-8977-24f92d420c51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3SEmpU2R4YR_gGqCPl15Kg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_5e6f53eb-d100-4231-a2ce-9885d73a4aa7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "poi_name": "Woodforest National Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1330 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e29-0513-743f-92a0-4f887b6c314e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a18e29-0513-743f-92a0-4f887b6c314e",
        "storage_key": "property/6767906449167905/01a18e29-0513-743f-92a0-4f887b6c314e.webp",
        "width": 1280,
        "height": 696
      },
      "poi_business_url": "https://www.woodforest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17469713508710277053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodforest-national-bank",
      "poi_latitude": "30.1615173",
      "poi_longitude": "-95.4547609",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-375-2505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167905/01a18e29-0dd8-7165-adc5-6fb9442c20ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a18e29-0dd8-7165-adc5-6fb9442c20ff",
        "storage_key": "property/6767906449167905/01a18e29-0dd8-7165-adc5-6fb9442c20ff.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJG8G10uo2R4YRvd-EruDjcPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    }
  ],
  "office_hours": [
    {
      "id": "ec_7e384ddad67f3f2411801733",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_64da5b499b81d85115f1112f",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d0ad16b2f7c9fa28e135d5b0",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ba4e05c6a5c5c03eb3c66f0a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    },
    {
      "id": "ec_d9abb6d74ee36e1712bb8aaa",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_15677f764d3cd63083ef0090",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_0fae158b259a6cf9061212f5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "rating": "5",
      "name": "B",
      "text": "I relocated from another state to Texas, and Neuhaus  is my first place of residence in the state, and I love it! Great location, building is kept in great shape, great neighbors, and an awesome community. The staff at Neuhaus have been outstanding. Kristin has done a fabulous job making me and my family feel welcomed to Texas and to the Neuhaus community.",
      "date": "2026-07-31",
      "title": "false"
    },
    {
      "id": "ec_eb4a6965ca01483ba28d2daa",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "rating": "5",
      "name": "Jeff Knapik",
      "text": "Great place to live, staff is excellent, the pool is always clean and family friendly.  My only complaint,   if I'm nitpicking, is the gates are seemingly always broken.  I drive a truck and the arms on the gates are very low and hard to see if you get too close.  When the gate opens, the arms (the ones that raise) still take a few seconds to respond, which is why I think soo many run thru the arms.",
      "date": "2026-04-20",
      "title": "false"
    },
    {
      "id": "ec_fb50d76b2ede84542b53029a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "rating": "5",
      "name": "jos",
      "text": "10/10 One of the nicest leasing agents Ive ever experienced! Kristin answered all of our questions and went above and beyond! Has very much convinced me to move out here!",
      "date": "2026-07-23",
      "title": "false"
    },
    {
      "id": "ec_5959a8bc703729dbe9d4328b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "rating": "5",
      "name": "Judith Sanchez",
      "text": "Very easy and fast process! Alexander is AMAZING! Helped us find our temporary home and made it a wonderful experience, toured multiple apartments, and gave us all the important information! Definitely recommend the complex, very quiet and taken care of. Can’t wait to see what else we have in store with Neuhaus!",
      "date": "2026-06-04",
      "title": "false"
    },
    {
      "id": "ec_0cfbc75dfbf7720e9af0db61",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "rating": "5",
      "name": "Jeramey Canty",
      "text": "Great experience starting my lease here! The process was smooth, professional, and stress free.\n\nBig thanks to Britni! She was super helpful, responsive, and made everything easy from start to finish. Highly recommend!",
      "date": "2026-04-08",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_a375bc2f-6741-4ded-95ad-0906f8694776",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Interactive Floor Plan Tours",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://widgets.peek.us/propertyGrid?agent_id=651c20ea647baaf9fb312aca"
    }
  ],
  "faqs": [],
  "pet_policies": [
    {
      "id": "ec_b5037c04dae0d24e5417350c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "dogs:Dog",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 20,
      "deposit": 0,
      "fee": 400,
      "monthly_rent": 30,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_3f2d9b2f75d0edc68bb9818c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "entrata",
      "external_id": "cats:Cat",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 20,
      "deposit": 0,
      "fee": 400,
      "monthly_rent": 30,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-spring-tx",
      "search_query": "resort-style pool apartments Spring TX",
      "category": "Amenity",
      "h1_title": "Resort-Style Pool Apartments in Spring, TX",
      "h2_subtitle": "Discover our luxurious apartments featuring a resort-style pool. Located in the heart of Spring, TX, Neuhaus offers upscale living with amazing perks.",
      "page_copy": "Experience the ultimate in relaxation and luxury at Neuhaus, where our Spring, TX apartments offer a stunning resort-style pool. Indulge in a community designed for comfort and enjoyment, complemented by impressive amenities like large island kitchens and outdoor gaming spaces. Ideal for those seeking an active lifestyle and a serene environment. \n\nLocated in the vibrant Grogan's Mill area, our private, gated community provides an escape from the ordinary. Residents enjoy spacious floor plans with elevated finishes, and the convenience of modern amenities such as wireless printing. Schedule a visit today and see why Neuhaus is the perfect choice for those seeking resort-style living in Spring, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Style Pool Apartments in Spring, TX",
      "seo_description": "Enjoy resort-style pool apartments at Neuhaus in Spring, TX. Experience luxury living with top amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "co-working-lounge-apartments-grogans-mill",
      "search_query": "co-working lounge apartments Grogan's Mill",
      "category": "Amenity",
      "h1_title": "Co-Working Lounge Apartments in Grogan's Mill",
      "h2_subtitle": "Explore apartments with a co-working lounge in Grogan's Mill. Our community offers modern amenities for a balanced lifestyle.",
      "page_copy": "Located in the desirable Grogan's Mill area, Neuhaus offers the perfect blend of modern living with on-demand co-working lounge facilities. Whether you're working remotely or need a quiet space to focus, our co-working lounge provides a productive environment paired with the comfort of home. Experience seamless connectivity and convenience with our wireless printing services.\n\nAt Neuhaus, enjoy more than just a working space. Our community is equipped with outdoor entertainment areas featuring gaming and grilling, making it ideal for both work and leisure. Discover spacious one-, two-, and three-bedroom layouts designed for modern lifestyles. Join our vibrant community in Grogan's Mill and enjoy an apartment tailored for productivity and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Co-Working Lounge Apartments Grogan's Mill",
      "seo_description": "Discover co-working lounge apartments in Grogan's Mill at Neuhaus. Modern living with on-site workspaces. Explore today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "in-unit-washer-dryer-montgomery-county-apartments",
      "search_query": "in-unit washer dryer Montgomery County apartments",
      "category": "Amenity",
      "h1_title": "In-Unit Washer Dryer Apartments in Montgomery County",
      "h2_subtitle": "Find apartments with in-unit washer and dryer in Montgomery County. Enjoy the convenience and modern living at Neuhaus.",
      "page_copy": "Discover the ease and convenience of in-unit washer and dryer facilities at Neuhaus, located in Montgomery County. Our spacious one-, two-, and three-bedroom apartments are designed to cater to your lifestyle, offering modern amenities that make daily living effortless. Say goodbye to laundromat trips and embrace a home that fits your needs.\n\nLocated within the vibrant community of Grogan's Mill, our apartments go beyond just providing essential in-unit amenities. Enjoy access to our outdoor entertainment spaces, covered carports, and a private, gated entry for added peace of mind. Experience a community focused on providing a well-rounded, comfortable living experience in Montgomery County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer Dryer Apartments Montgomery County",
      "seo_description": "Enjoy in-unit washer dryer in Montgomery County at Neuhaus. Comfortable, convenient living in a vibrant community. Explore today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-grogans-mill",
      "search_query": "dog friendly apartments in Grogan's Mill",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Grogan's Mill",
      "h2_subtitle": "Explore our dog-friendly apartments in Grogan's Mill. Neuhaus offers a perfect home for you and your furry friend with top-notch amenities.",
      "page_copy": "At Neuhaus, we understand that pets are part of the family. Our dog-friendly apartments in Grogan's Mill provide the ideal setting for both you and your furry companions. With spacious layouts and community perks like outdoor entertainment areas, you and your pet will have plenty of room to enjoy together.\n\nOur private, gated community ensures a safe environment, while features like large island kitchens and covered carports enhance your living experience. Situated in the heart of Grogan's Mill, Neuhaus offers modern living spaces that perfectly balance style and comfort. Visit us to see why our pet-friendly community is the perfect choice for you and your pet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Grogan's Mill",
      "seo_description": "Discover dog-friendly apartments in Grogan's Mill at Neuhaus. Spacious living with pet-friendly amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "state-of-the-art-fitness-center-apartments-77380",
      "search_query": "state-of-the-art fitness center apartments in 77380",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in 77380",
      "h2_subtitle": "Discover apartments with a state-of-the-art fitness center in the 77380 area. Neuhaus offers modern amenities for an active lifestyle.",
      "page_copy": "Situated in the 77380 area, Neuhaus offers residents access to a state-of-the-art fitness center, perfect for maintaining an active and healthy lifestyle. Our community is designed to provide both top-notch exercise facilities and a relaxing living environment.\n\nIn addition to our fitness center, residents enjoy large island kitchens and outdoor gaming and grilling spaces, making Neuhaus the ideal home for those who value both health and comfort. With flexible one-, two-, and three-bedroom layouts, our community is equipped to support your lifestyle in Spring, TX. Experience a vibrant community that promotes wellness and modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in 77380",
      "seo_description": "Discover state-of-the-art fitness center apartments in 77380 at Neuhaus. Enjoy modern amenities and active lifestyle. Explore now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-spring-tx",
      "search_query": "1 bedroom apartments in Spring TX",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Spring, TX",
      "h2_subtitle": "Explore our stylish 1 bedroom apartments in Spring, TX. Neuhaus offers modern living with exceptional amenities and flexible spaces.",
      "page_copy": "Neuhaus provides modern one-bedroom apartments in Spring, TX, perfect for those seeking both comfort and style. Our residences feature elevated finishes and are designed with your convenience in mind, from large island kitchens to private, gated access. Enjoy a lifestyle that blends functionality with contemporary aesthetics.\n\nLocated in the vibrant community of Grogan's Mill, our one-bedroom layouts offer ample living space, complemented by resort-style amenities such as outdoor entertainment areas and wireless printing services. Discover a home that caters to your lifestyle needs, right here in Spring, TX. Schedule a tour today and experience Neuhaus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Spring, TX",
      "seo_description": "Find modern 1 bedroom apartments in Spring, TX at Neuhaus. Enjoy exceptional amenities in a vibrant community. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "2-bedroom-layouts-grogans-mill",
      "search_query": "2 bedroom layouts in Grogan's Mill",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Layouts in Grogan's Mill",
      "h2_subtitle": "Discover our spacious 2 bedroom layouts in Grogan's Mill. Neuhaus offers modern living with premium finishes and community amenities.",
      "page_copy": "Experience the perfect balance of space and modern design with our 2 bedroom layouts in Grogan's Mill. Neuhaus offers versatile floor plans, ideal for a comfortable living experience in Spring, TX. Each layout is thoughtfully crafted to provide the perfect combination of style and functionality.\n\nResidents of Neuhaus enjoy premium amenities such as outdoor entertainment spaces, large island kitchens, and secure, gated access. Located in the dynamic Grogan's Mill area, our community invites you to enjoy contemporary living with the added convenience of a vibrant neighborhood. Visit us and see why our 2 bedroom layouts are the perfect fit for your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Layouts in Grogan's Mill",
      "seo_description": "Explore spacious 2 bedroom layouts in Grogan's Mill at Neuhaus. Modern design with community perks for a complete living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "3-bedroom-floor-plans-montgomery-county",
      "search_query": "3 bedroom floor plans Montgomery County",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Floor Plans in Montgomery County",
      "h2_subtitle": "Explore our spacious 3 bedroom floor plans in Montgomery County. Neuhaus offers modern design and resort-style amenities in a prime location.",
      "page_copy": "Discover the perfect blend of comfort and style with our 3 bedroom floor plans in Montgomery County at Neuhaus. Designed to accommodate your lifestyle, these spacious layouts provide ample room for families or those who desire extra space. Each apartment features modern finishes, fostering an environment of elegance and practicality.\n\nSituated in the vibrant Grogan's Mill area, Neuhaus offers residents exclusive access to resort-style amenities such as outdoor entertainment spaces, a state-of-the-art fitness center, and more. Experience a living environment that combines convenience and sophistication, all in an ideal location within Montgomery County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Floor Plans in Montgomery County",
      "seo_description": "Explore spacious 3 bedroom floor plans in Montgomery County at Neuhaus. Enjoy modern design and luxurious amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "apartments-near-lone-star-college-montgomery",
      "search_query": "apartments near lone star college montgomery grogan's mill",
      "category": "School",
      "h1_title": "Apartments Near Lone Star College Montgomery",
      "h2_subtitle": "Find stylish apartments near Lone Star College Montgomery in Grogan's Mill. Neuhaus offers modern amenities and convenient access in Spring, TX.",
      "page_copy": "Located just a short drive away, Neuhaus offers ideal apartments near Lone Star College Montgomery in Grogan's Mill. These thoughtfully designed one-, two-, and three-bedroom layouts provide an excellent living environment for students and professionals alike, featuring modern finishes and flexible spaces.\n\nEnjoy resort-style amenities including outdoor entertainment areas, large island kitchens, and a private, gated community, enhancing your living experience. Neuhaus in Grogan's Mill combines convenience and lifestyle, providing easy access to educational and cultural opportunities at Lone Star College Montgomery, making it a perfect choice for anyone looking to live, learn, and thrive in Spring, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lone Star College Montgomery",
      "seo_description": "Discover Neuhaus, stylish apartments near Lone Star College Montgomery. Enjoy modern amenities in Grogan's Mill, Spring, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "student-housing-lone-star-college-montgomery-spring-tx",
      "search_query": "student housing close to lone star college montgomery spring tx",
      "category": "School",
      "h1_title": "Student Housing Near Lone Star College Montgomery",
      "h2_subtitle": "Explore student housing close to Lone Star College Montgomery in Spring, TX. Neuhaus offers modern amenities and convenient living.",
      "page_copy": "Neuhaus provides an excellent option for student housing close to Lone Star College Montgomery in Spring, TX. Our community is designed with students in mind, offering flexible living spaces that cater to both study and relaxation. Choose from a range of modern one-, two-, and three-bedroom apartment layouts, each featuring quality finishes and design.\n\nLocated in the vibrant Grogan's Mill neighborhood, Neuhaus offers an engaging community with amenities like outdoor entertainment areas and wireless printing. Our proximity to Lone Star College Montgomery ensures that your academic pursuits are seamlessly integrated into your everyday life. Experience the perfect blend of convenience and style at Neuhaus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Student Housing Near Lone Star College Montgomery",
      "seo_description": "Find student housing near Lone Star College Montgomery at Neuhaus. Enjoy modern amenities in Spring, TX, ideal for students.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "off-campus-apartments-lone-star-college-montgomery-county",
      "search_query": "off-campus apartments by lone star college montgomery montgomery county",
      "category": "School",
      "h1_title": "Off-Campus Apartments by Lone Star College",
      "h2_subtitle": "Discover off-campus apartments by Lone Star College Montgomery in Montgomery County. Neuhaus offers modern living with convenient access.",
      "page_copy": "Neuhaus in Montgomery County offers the ideal off-campus living experience near Lone Star College Montgomery. Our stylish apartment community provides students with a comfortable, convenient environment perfect for balancing study and leisure. Choose from spacious one-, two-, or three-bedroom layouts, each featuring upscale finishes and flexible spaces.\n\nConveniently located in the lively Grogan's Mill area, Neuhaus ensures that students are close to campus while enjoying the advantages of resort-style community amenities, including wireless printing and outdoor entertainment areas. Make Neuhaus your home for an unparalleled off-campus living experience in Montgomery County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Off-Campus Apartments by Lone Star College Montgomery",
      "seo_description": "Explore off-campus apartments near Lone Star College Montgomery in Montgomery County at Neuhaus. Modern living close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "apartments-near-texas-childrens-hospital-woodlands",
      "search_query": "apartments near Texas Children's Hospital The Woodlands in Grogan's Mill",
      "category": "Hospital",
      "h1_title": "Apartments Near Texas Children's Hospital",
      "h2_subtitle": "Find convenient apartments near Texas Children's Hospital The Woodlands in Grogan's Mill. Neuhaus offers modern amenities and flexibility.",
      "page_copy": "Neuhaus offers an exceptional living experience with apartments located near Texas Children's Hospital The Woodlands in Grogan's Mill. Our community is perfect for professionals seeking proximity to work with the comfort of modern living. Choose from one-, two-, or three-bedroom apartments equipped with stylish finishes and spacious designs.\n\nResidents enjoy premium amenities like a private, gated community, outdoor entertainment spaces, and large island kitchens. Situated in the dynamic Grogan's Mill neighborhood, Neuhaus provides easy access to both workplace and local attractions, making it an ideal choice for anyone working at The Woodlands medical facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Texas Children's Hospital The Woodlands",
      "seo_description": "Discover Neuhaus, convenient apartments near Texas Children's Hospital The Woodlands in Grogan's Mill, blending modern amenities with easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "apartments-near-northshore-park-spring-tx",
      "search_query": "apartments near Northshore Park Spring TX",
      "category": "Park",
      "h1_title": "Apartments Near Northshore Park, Spring TX",
      "h2_subtitle": "Explore comfortable living in apartments near Northshore Park, Spring TX. Discover what Neuhaus has to offer in the heart of nature.",
      "page_copy": "Located in close proximity to Northshore Park in Spring, TX, Neuhaus offers a premium apartment living experience surrounded by lush landscapes. Our community presents a unique combination of natural beauty and modern amenities, appealing to those who love outdoor activities and scenic views. Choose from a variety of one-, two-, and three-bedroom layouts that fit your lifestyle.\n\nNeuhaus residents enjoy a range of community features like outdoor entertainment spaces, wireless printing facilities, and the security of a gated environment. With easy access to the recreational opportunities at Northshore Park, Neuhaus provides an ideal setting for those seeking both relaxation and adventure in their daily lives.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Northshore Park, Spring TX",
      "seo_description": "Neuhaus offers modern apartments near Northshore Park in Spring, TX. Enjoy contemporary amenities close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "park-side-apartments-bear-branch-park-grogans-mill",
      "search_query": "park-side apartments near Bear Branch Park Grogan's Mill",
      "category": "Park",
      "h1_title": "Park-Side Apartments Near Bear Branch Park",
      "h2_subtitle": "Discover park-side apartments near Bear Branch Park in Grogan’s Mill. Experience the blend of nature and modern living at Neuhaus.",
      "page_copy": "Neuhaus offers exceptional park-side apartment living, just steps away from Bear Branch Park in Grogan's Mill. Our community provides residents with the perfect balance of urban convenience and natural beauty, making it ideal for nature lovers and outdoor enthusiasts. Choose from a selection of refined apartment layouts, all featuring high-end finishes and generous spaces.\n\nResidents at Neuhaus benefit from a variety of upscale amenities, including outdoor entertainment areas and secure gated access. Situated in the vibrant neighborhood of Grogan’s Mill, Neuhaus ensures easy access to the tranquil outdoors of Bear Branch Park, offering a unique, peaceful living experience unparalleled in the area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park-Side Apartments Near Bear Branch Park",
      "seo_description": "Explore Neuhaus's park-side apartments near Bear Branch Park in Grogan's Mill. Experience a serene blend of nature and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "rentals-by-rob-fleming-park-montgomery-county",
      "search_query": "rentals by Rob Fleming Park Montgomery County",
      "category": "Park",
      "h1_title": "Rentals by Rob Fleming Park",
      "h2_subtitle": "Find stylish rentals by Rob Fleming Park in Montgomery County. Neuhaus offers a blend of convenience and modern living.",
      "page_copy": "Situated conveniently by Rob Fleming Park, Neuhaus offers premium rentals in the heart of Montgomery County. Our community blends the best of modern amenities with the beauty of nearby nature, making it the perfect place to call home. With a choice of one-, two-, and three-bedroom apartments, you'll find the space and style you desire.\n\nEnjoy the benefits of living near Rob Fleming Park while having access to Neuhaus's top-tier amenities, such as outdoor recreation spaces, wireless printing, and a private, gated environment. Our prime location combines easy access to both the serenity of nature and the vibrancy of urban life, ensuring a unique experience for all our residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Rob Fleming Park in Montgomery County",
      "seo_description": "Discover rentals near Rob Fleming Park in Montgomery County at Neuhaus. Enjoy modern living and proximity to nature in a peaceful setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "apartments-close-to-bridgestone-park-77380",
      "search_query": "apartments close to Bridgestone Park 77380",
      "category": "Park",
      "h1_title": "Apartments Close to Bridgestone Park",
      "h2_subtitle": "Explore apartments close to Bridgestone Park in the 77380 area. Discover modern living at Neuhaus, nestled in Spring, TX.",
      "page_copy": "Neuhaus offers stunning apartment homes situated close to Bridgestone Park in the desirable 77380 area. Our community is ideal for those who appreciate both convenient access to nature and upscale living. With our selection of one-, two-, and three-bedroom apartments, you'll find the perfect place to match your lifestyle.\n\nAt Neuhaus, residents enjoy a variety of luxe amenities, including a relaxing outdoor entertainment space, state-of-the-art wireless printing, and the security of a gated community. Located near Bridgestone Park, our community provides a harmonious balance between tranquil surroundings and modern conveniences, making it a sought-after choice for Spring, TX living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Bridgestone Park, 77380",
      "seo_description": "Discover apartments near Bridgestone Park in 77380 at Neuhaus. Enjoy modern amenities and beautiful surroundings in Spring, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162393",
      "property_id": "6767906449167905",
      "source": "generator",
      "page_item_url": "living-near-town-green-park-woodlands-tx",
      "search_query": "living near Town Green Park Woodlands TX",
      "category": "Park",
      "h1_title": "Living Near Town Green Park",
      "h2_subtitle": "Experience living near Town Green Park in Woodlands, TX. Neuhaus offers modern comforts in a prime location.",
      "page_copy": "Neuhaus invites you to experience the allure of living near Town Green Park in the vibrant Woodlands, TX. Our community provides an ideal setting for those looking to blend urban conveniences with green spaces. Choose from our array of one-, two-, and three-bedroom apartments, each designed with contemporary finishes and thoughtful layouts.\n\nResidents at Neuhaus enjoy the perks of an active lifestyle with proximity to Town Green Park. Our amenities include a private, gated community, areas for outdoor entertainment, and flexible living spaces. Discover a seamless integration of nature and modernity, making Neuhaus a top choice for those seeking a dynamic living environment in Woodlands, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "01a17956-e2cf-7338-8f49-159fa53d2adf",
        "storage_key": "property/6767906449167905/01a17956-e2cf-7338-8f49-159fa53d2adf.webp",
        "width": 400,
        "height": 640
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Town Green Park, Woodlands TX",
      "seo_description": "Neuhaus offers the ultimate living experience near Town Green Park in Woodlands, TX. Enjoy modern luxury and access to vibrant community life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "13387209498"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywy7rk7wq0"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_nurture_boss_scheduler_url",
      "type": "STRING",
      "value": "https://www.theonsiteteam.com/schedule-tour?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2YWUzNmFiMWU2NDkwNThmODc1OTBlYTMiLCJwcm9wZXJ0eU5hbWUiOiJOZXVoYXVzIFdvb2RsYW5kcyIsImlhdCI6MTc5MzI4OTQ4M30.p4t0JScs8-IiuF0grGlskko3nB4pQlCJiuxEgVDz9ww"
    },
    {
      "ID": "custom_nurture_boss_chatbot_script",
      "type": "STRING",
      "value": "<script defer src=\"https://widget.nurtureboss.io/widget.js\" id=\"nb-widget-script\" data-token=\"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2YWUzNmFiMWU2NDkwNThmODc1OTBlYTMiLCJwcm9wZXJ0eU5hbWUiOiJOZXVoYXVzIFdvb2RsYW5kcyIsImlhdCI6MTc5MzI4OTQ4M30.p4t0JScs8-IiuF0grGlskko3nB4pQlCJiuxEgVDz9ww\"></script>"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "13387209498",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/1ywy7rk7wq0",
  "custom_website_subscription": "turnkey",
  "custom_nurture_boss_scheduler_url": "https://www.theonsiteteam.com/schedule-tour?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2YWUzNmFiMWU2NDkwNThmODc1OTBlYTMiLCJwcm9wZXJ0eU5hbWUiOiJOZXVoYXVzIFdvb2RsYW5kcyIsImlhdCI6MTc5MzI4OTQ4M30.p4t0JScs8-IiuF0grGlskko3nB4pQlCJiuxEgVDz9ww",
  "custom_nurture_boss_chatbot_script": "<script defer src=\"https://widget.nurtureboss.io/widget.js\" id=\"nb-widget-script\" data-token=\"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2YWUzNmFiMWU2NDkwNThmODc1OTBlYTMiLCJwcm9wZXJ0eU5hbWUiOiJOZXVoYXVzIFdvb2RsYW5kcyIsImlhdCI6MTc5MzI4OTQ4M30.p4t0JScs8-IiuF0grGlskko3nB4pQlCJiuxEgVDz9ww\"></script>",
  "custom_audioeye_site_id": "0d5da69d-f2da-4a98-814b-1cb0ca39e14a",
  "custom_audioeye_site_hash": "4ddb49f2489bd94b790e252f3ec24b8c"
};

export const generatedAt = '2026-11-05T18:34:41.272Z';
